<template>
  <div class="pagina">
    <!-- Header -->
    <header class="header">
      <img src="/img/logo-preta.png" height="36" alt="Bike Registrada" />
    </header>

    <!-- Steps -->
    <RegistroBikeStepper :current-step="1" :steps="['Dados pessoais', 'Tipos de registro', 'Finalização']" />

    <!-- Conteúdo -->
    <div class="conteudo">
      <div class="page-content">
        <h2 class="titulo">
          <span class="nome-destaque">{{ nome }}</span>, temos 3 registros para a sua bike!
        </h2>
        <p class="subtitulo">Qual deles melhor se encaixa para você?</p>

        <!-- Seletor de planos -->
        <div class="tab-planos" ref="planosSection">
          <button class="tab-plano" :class="{ ativo: planSelecionado === 'basic' }" @click="selecionarPlano('basic')">
            <span class="tab-nome">Basic</span>
            <span class="tab-preco">Gratuito</span>
          </button>
          <button class="tab-plano" :class="{ ativo: planSelecionado === 'starter' }"
            @click="selecionarPlano('starter')">
            <span class="tab-nome">Starter</span>
            <span class="tab-preco">R$ 9,90/mês</span>
          </button>
          <button class="tab-plano tab-plano--destaque" :class="{ ativo: planSelecionado === 'premium' }"
            @click="selecionarPlano('premium')">
            <span class="tab-badge">40% OFF</span>
            <span class="tab-nome">Premium</span>
            <span class="tab-preco">R$ 29,90/mês</span>
          </button>
        </div>

        <div class="planos-grid planos-desktop">

          <!-- Basic -->
          <div class="plano-wrapper">
            <div class="badge-espaco"></div>
            <div class="plano-card" :class="{ selecionado: planSelecionado === 'basic' }"
              @click="selecionarPlano('basic')">
              <div class="plano-topo">
                <div class="checkbox-icone">
                  <svg v-if="planSelecionado === 'basic'" width="40" height="40" viewBox="0 0 38 38" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect width="38" height="38" rx="8" fill="#A6E894" />
                    <path
                      d="M14.395 28.5C13.6569 28.5003 12.9491 28.2034 12.4277 27.6746L6.47998 21.656C5.84001 21.0079 5.84001 19.9574 6.47998 19.3093C7.12016 18.6615 8.1579 18.6615 8.79808 19.3093L14.395 24.9751L29.2019 9.98589C29.8421 9.33804 30.8798 9.33804 31.52 9.98589C32.16 10.6339 32.16 11.6845 31.52 12.3325L16.3622 27.6746C15.8408 28.2034 15.133 28.5003 14.395 28.5Z"
                      fill="#4FA935" />
                  </svg>
                  <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="7" stroke="#D1D5DC" stroke-width="2" />
                  </svg>
                </div>
                <div class="plano-info">
                  <span class="plano-tipo-label">Registro</span>
                  <span class="plano-nome">Basic</span>
                </div>
              </div>
              <p class="plano-descricao">No plano <strong class="destaque-plano">Basic</strong> você tem:</p>
              <ul class="features-list">
                <li v-for="f in planos.basic.features" :key="f">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17L4 12" stroke="#4FA935" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  {{ f }}
                </li>
              </ul>
              <div class="plano-beneficios" @click.stop="abrirModal('basic')">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.6667 5.83333H15.2183C15.6895 5.418 16.0635 4.90407 16.3138 4.328C16.5641 3.75193 16.6846 3.12784 16.6667 2.5C16.6667 2.27899 16.5789 2.06702 16.4226 1.91074C16.2663 1.75446 16.0543 1.66667 15.8333 1.66667C15.6123 1.66667 15.4004 1.75446 15.2441 1.91074C15.0878 2.06702 15 2.27899 15 2.5C15 4.685 13.0242 5.44167 11.5217 5.70083C12.0762 4.71755 12.4101 3.62531 12.5 2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5C7.58992 3.62531 7.92376 4.71755 8.47833 5.70083C6.97583 5.44167 5 4.685 5 2.5C5 2.27899 4.9122 2.06702 4.75592 1.91074C4.59964 1.75446 4.38768 1.66667 4.16667 1.66667C3.94565 1.66667 3.73369 1.75446 3.57741 1.91074C3.42113 2.06702 3.33333 2.27899 3.33333 2.5C3.31543 3.12784 3.4359 3.75193 3.6862 4.328C3.9365 4.90407 4.3105 5.418 4.78167 5.83333H3.33333C2.44928 5.83333 1.60143 6.18452 0.976311 6.80964C0.35119 7.43476 0 8.28261 0 9.16667L0 10C0 10.442 0.175595 10.8659 0.488155 11.1785C0.800716 11.4911 1.22464 11.6667 1.66667 11.6667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H14.1667C15.2713 19.9987 16.3304 19.5593 17.1115 18.7782C17.8926 17.997 18.332 16.938 18.3333 15.8333V11.6667C18.7754 11.6667 19.1993 11.4911 19.5118 11.1785C19.8244 10.8659 20 10.442 20 10V9.16667C20 8.28261 19.6488 7.43476 19.0237 6.80964C18.3986 6.18452 17.5507 5.83333 16.6667 5.83333ZM10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5C10.7327 3.38569 10.4489 4.24076 10 5.01083C9.55106 4.24076 9.26726 3.38569 9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56702 1.75446 9.77899 1.66667 10 1.66667ZM1.66667 9.16667C1.66667 8.72464 1.84226 8.30072 2.15482 7.98816C2.46738 7.67559 2.89131 7.5 3.33333 7.5H9.16667V10H1.66667V9.16667ZM3.33333 15.8333V11.6667H9.16667V18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333ZM16.6667 15.8333C16.6667 16.4964 16.4033 17.1323 15.9344 17.6011C15.4656 18.0699 14.8297 18.3333 14.1667 18.3333H10.8333V11.6667H16.6667V15.8333ZM10.8333 10V7.5H16.6667C17.1087 7.5 17.5326 7.67559 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V10H10.8333Z"
                    fill="#4FA935" />
                </svg>
                <span>Confira os benefícios</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.05216 14.9937C4.05199 14.8624 4.07782 14.7323 4.12816 14.611C4.17851 14.4897 4.25237 14.3796 4.3455 14.287L9.46016 9.17169C9.61497 9.01692 9.73778 8.83317 9.82156 8.63093C9.90535 8.42869 9.94847 8.21193 9.94847 7.99302C9.94847 7.77411 9.90535 7.55735 9.82156 7.35511C9.73778 7.15287 9.61497 6.96912 9.46016 6.81435L4.35216 1.70702C4.25665 1.61477 4.18047 1.50443 4.12806 1.38242C4.07565 1.26042 4.04807 1.1292 4.04691 0.996422C4.04576 0.863642 4.07106 0.731962 4.12134 0.609066C4.17162 0.486169 4.24588 0.374517 4.33977 0.280625C4.43366 0.186732 4.54531 0.112479 4.66821 0.0621986C4.79111 0.0119171 4.92278 -0.0133839 5.05556 -0.0122299C5.18834 -0.011076 5.31956 0.0165091 5.44157 0.0689182C5.56357 0.121327 5.67392 0.197509 5.76616 0.293019L10.8742 5.40035C11.5609 6.08841 11.9467 7.02086 11.9467 7.99302C11.9467 8.96518 11.5609 9.89763 10.8742 10.5857L5.7595 15.701C5.61964 15.841 5.44142 15.9363 5.24738 15.9749C5.05334 16.0135 4.8522 15.9937 4.66942 15.918C4.48664 15.8423 4.33042 15.714 4.22055 15.5495C4.11067 15.385 4.05207 15.1915 4.05216 14.9937Z"
                    fill="#4FA935" />
                </svg>
              </div>
              <div class="plano-preco">
                <span class="preco-gratuito">Gratuito</span>
              </div>
            </div>
          </div>

          <!-- Starter -->
          <div class="plano-wrapper">
            <div class="badge-destaque">Mais popular</div>
            <div class="plano-card plano-card--destaque" :class="{ selecionado: planSelecionado === 'starter' }"
              @click="selecionarPlano('starter')">
              <div class="plano-topo">
                <div class="checkbox-icone">
                  <svg v-if="planSelecionado === 'starter'" width="40" height="40" viewBox="0 0 38 38" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect width="38" height="38" rx="8" fill="#A6E894" />
                    <path
                      d="M14.395 28.5C13.6569 28.5003 12.9491 28.2034 12.4277 27.6746L6.47998 21.656C5.84001 21.0079 5.84001 19.9574 6.47998 19.3093C7.12016 18.6615 8.1579 18.6615 8.79808 19.3093L14.395 24.9751L29.2019 9.98589C29.8421 9.33804 30.8798 9.33804 31.52 9.98589C32.16 10.6339 32.16 11.6845 31.52 12.3325L16.3622 27.6746C15.8408 28.2034 15.133 28.5003 14.395 28.5Z"
                      fill="#4FA935" />
                  </svg>
                  <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="7" stroke="#D1D5DC" stroke-width="2" />
                  </svg>
                </div>
                <div class="plano-info">
                  <span class="plano-tipo-label">Registro</span>
                  <span class="plano-nome">Starter</span>
                </div>
              </div>
              <p class="plano-descricao">Tenha tudo do <strong class="destaque-plano">Basic</strong> e mais:</p>
              <ul class="features-list features-list--2col">
                <li v-for="f in planos.starter.features" :key="f">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17L4 12" stroke="#4FA935" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  {{ f }}
                </li>
              </ul>
              <div class="plano-beneficios" @click.stop="abrirModal('starter')">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.6667 5.83333H15.2183C15.6895 5.418 16.0635 4.90407 16.3138 4.328C16.5641 3.75193 16.6846 3.12784 16.6667 2.5C16.6667 2.27899 16.5789 2.06702 16.4226 1.91074C16.2663 1.75446 16.0543 1.66667 15.8333 1.66667C15.6123 1.66667 15.4004 1.75446 15.2441 1.91074C15.0878 2.06702 15 2.27899 15 2.5C15 4.685 13.0242 5.44167 11.5217 5.70083C12.0762 4.71755 12.4101 3.62531 12.5 2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5C7.58992 3.62531 7.92376 4.71755 8.47833 5.70083C6.97583 5.44167 5 4.685 5 2.5C5 2.27899 4.9122 2.06702 4.75592 1.91074C4.59964 1.75446 4.38768 1.66667 4.16667 1.66667C3.94565 1.66667 3.73369 1.75446 3.57741 1.91074C3.42113 2.06702 3.33333 2.27899 3.33333 2.5C3.31543 3.12784 3.4359 3.75193 3.6862 4.328C3.9365 4.90407 4.3105 5.418 4.78167 5.83333H3.33333C2.44928 5.83333 1.60143 6.18452 0.976311 6.80964C0.35119 7.43476 0 8.28261 0 9.16667L0 10C0 10.442 0.175595 10.8659 0.488155 11.1785C0.800716 11.4911 1.22464 11.6667 1.66667 11.6667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H14.1667C15.2713 19.9987 16.3304 19.5593 17.1115 18.7782C17.8926 17.997 18.332 16.938 18.3333 15.8333V11.6667C18.7754 11.6667 19.1993 11.4911 19.5118 11.1785C19.8244 10.8659 20 10.442 20 10V9.16667C20 8.28261 19.6488 7.43476 19.0237 6.80964C18.3986 6.18452 17.5507 5.83333 16.6667 5.83333ZM10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5C10.7327 3.38569 10.4489 4.24076 10 5.01083C9.55106 4.24076 9.26726 3.38569 9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56702 1.75446 9.77899 1.66667 10 1.66667ZM1.66667 9.16667C1.66667 8.72464 1.84226 8.30072 2.15482 7.98816C2.46738 7.67559 2.89131 7.5 3.33333 7.5H9.16667V10H1.66667V9.16667ZM3.33333 15.8333V11.6667H9.16667V18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333ZM16.6667 15.8333C16.6667 16.4964 16.4033 17.1323 15.9344 17.6011C15.4656 18.0699 14.8297 18.3333 14.1667 18.3333H10.8333V11.6667H16.6667V15.8333ZM10.8333 10V7.5H16.6667C17.1087 7.5 17.5326 7.67559 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V10H10.8333Z"
                    fill="#4FA935" />
                </svg>
                <span>Confira os benefícios</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.05216 14.9937C4.05199 14.8624 4.07782 14.7323 4.12816 14.611C4.17851 14.4897 4.25237 14.3796 4.3455 14.287L9.46016 9.17169C9.61497 9.01692 9.73778 8.83317 9.82156 8.63093C9.90535 8.42869 9.94847 8.21193 9.94847 7.99302C9.94847 7.77411 9.90535 7.55735 9.82156 7.35511C9.73778 7.15287 9.61497 6.96912 9.46016 6.81435L4.35216 1.70702C4.25665 1.61477 4.18047 1.50443 4.12806 1.38242C4.07565 1.26042 4.04807 1.1292 4.04691 0.996422C4.04576 0.863642 4.07106 0.731962 4.12134 0.609066C4.17162 0.486169 4.24588 0.374517 4.33977 0.280625C4.43366 0.186732 4.54531 0.112479 4.66821 0.0621986C4.79111 0.0119171 4.92278 -0.0133839 5.05556 -0.0122299C5.18834 -0.011076 5.31956 0.0165091 5.44157 0.0689182C5.56357 0.121327 5.67392 0.197509 5.76616 0.293019L10.8742 5.40035C11.5609 6.08841 11.9467 7.02086 11.9467 7.99302C11.9467 8.96518 11.5609 9.89763 10.8742 10.5857L5.7595 15.701C5.61964 15.841 5.44142 15.9363 5.24738 15.9749C5.05334 16.0135 4.8522 15.9937 4.66942 15.918C4.48664 15.8423 4.33042 15.714 4.22055 15.5495C4.11067 15.385 4.05207 15.1915 4.05216 14.9937Z"
                    fill="#4FA935" />
                </svg>
              </div>
              <div class="plano-preco">
                <div class="preco-de">
                  <span class="preco-original">De: R$19,90</span>
                  <span class="badge-desconto">15% off</span>
                </div>
                <div class="preco-valor">
                  <span class="preco-cifrao">R$</span><span class="preco-numero">9</span><span
                    class="preco-centavos">,90/mês</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Premium -->
          <div class="plano-wrapper">
            <div class="badge-destaque">Mais benéfico</div>
            <div class="plano-card plano-card--destaque" :class="{ selecionado: planSelecionado === 'premium' }"
              @click="selecionarPlano('premium')">
              <div class="plano-topo">
                <div class="checkbox-icone">
                  <svg v-if="planSelecionado === 'premium'" width="40" height="40" viewBox="0 0 38 38" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect width="38" height="38" rx="8" fill="#A6E894" />
                    <path
                      d="M14.395 28.5C13.6569 28.5003 12.9491 28.2034 12.4277 27.6746L6.47998 21.656C5.84001 21.0079 5.84001 19.9574 6.47998 19.3093C7.12016 18.6615 8.1579 18.6615 8.79808 19.3093L14.395 24.9751L29.2019 9.98589C29.8421 9.33804 30.8798 9.33804 31.52 9.98589C32.16 10.6339 32.16 11.6845 31.52 12.3325L16.3622 27.6746C15.8408 28.2034 15.133 28.5003 14.395 28.5Z"
                      fill="#4FA935" />
                  </svg>
                  <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="7" stroke="#D1D5DC" stroke-width="2" />
                  </svg>
                </div>
                <div class="plano-info">
                  <span class="plano-tipo-label">Registro</span>
                  <span class="plano-nome">Premium</span>
                </div>
              </div>
              <p class="plano-descricao">Tenha tudo do <strong class="destaque-plano">Starter</strong> e mais:</p>
              <ul class="features-list features-list--2col">
                <li v-for="f in planos.premium.features" :key="f">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17L4 12" stroke="#4FA935" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  {{ f }}
                </li>
              </ul>
              <div class="plano-beneficios" @click.stop="abrirModal('premium')">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.6667 5.83333H15.2183C15.6895 5.418 16.0635 4.90407 16.3138 4.328C16.5641 3.75193 16.6846 3.12784 16.6667 2.5C16.6667 2.27899 16.5789 2.06702 16.4226 1.91074C16.2663 1.75446 16.0543 1.66667 15.8333 1.66667C15.6123 1.66667 15.4004 1.75446 15.2441 1.91074C15.0878 2.06702 15 2.27899 15 2.5C15 4.685 13.0242 5.44167 11.5217 5.70083C12.0762 4.71755 12.4101 3.62531 12.5 2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5C7.58992 3.62531 7.92376 4.71755 8.47833 5.70083C6.97583 5.44167 5 4.685 5 2.5C5 2.27899 4.9122 2.06702 4.75592 1.91074C4.59964 1.75446 4.38768 1.66667 4.16667 1.66667C3.94565 1.66667 3.73369 1.75446 3.57741 1.91074C3.42113 2.06702 3.33333 2.27899 3.33333 2.5C3.31543 3.12784 3.4359 3.75193 3.6862 4.328C3.9365 4.90407 4.3105 5.418 4.78167 5.83333H3.33333C2.44928 5.83333 1.60143 6.18452 0.976311 6.80964C0.35119 7.43476 0 8.28261 0 9.16667L0 10C0 10.442 0.175595 10.8659 0.488155 11.1785C0.800716 11.4911 1.22464 11.6667 1.66667 11.6667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H14.1667C15.2713 19.9987 16.3304 19.5593 17.1115 18.7782C17.8926 17.997 18.332 16.938 18.3333 15.8333V11.6667C18.7754 11.6667 19.1993 11.4911 19.5118 11.1785C19.8244 10.8659 20 10.442 20 10V9.16667C20 8.28261 19.6488 7.43476 19.0237 6.80964C18.3986 6.18452 17.5507 5.83333 16.6667 5.83333ZM10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5C10.7327 3.38569 10.4489 4.24076 10 5.01083C9.55106 4.24076 9.26726 3.38569 9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56702 1.75446 9.77899 1.66667 10 1.66667ZM1.66667 9.16667C1.66667 8.72464 1.84226 8.30072 2.15482 7.98816C2.46738 7.67559 2.89131 7.5 3.33333 7.5H9.16667V10H1.66667V9.16667ZM3.33333 15.8333V11.6667H9.16667V18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333ZM16.6667 15.8333C16.6667 16.4964 16.4033 17.1323 15.9344 17.6011C15.4656 18.0699 14.8297 18.3333 14.1667 18.3333H10.8333V11.6667H16.6667V15.8333ZM10.8333 10V7.5H16.6667C17.1087 7.5 17.5326 7.67559 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V10H10.8333Z"
                    fill="#4FA935" />
                </svg>
                <span>Confira os benefícios</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.05216 14.9937C4.05199 14.8624 4.07782 14.7323 4.12816 14.611C4.17851 14.4897 4.25237 14.3796 4.3455 14.287L9.46016 9.17169C9.61497 9.01692 9.73778 8.83317 9.82156 8.63093C9.90535 8.42869 9.94847 8.21193 9.94847 7.99302C9.94847 7.77411 9.90535 7.55735 9.82156 7.35511C9.73778 7.15287 9.61497 6.96912 9.46016 6.81435L4.35216 1.70702C4.25665 1.61477 4.18047 1.50443 4.12806 1.38242C4.07565 1.26042 4.04807 1.1292 4.04691 0.996422C4.04576 0.863642 4.07106 0.731962 4.12134 0.609066C4.17162 0.486169 4.24588 0.374517 4.33977 0.280625C4.43366 0.186732 4.54531 0.112479 4.66821 0.0621986C4.79111 0.0119171 4.92278 -0.0133839 5.05556 -0.0122299C5.18834 -0.011076 5.31956 0.0165091 5.44157 0.0689182C5.56357 0.121327 5.67392 0.197509 5.76616 0.293019L10.8742 5.40035C11.5609 6.08841 11.9467 7.02086 11.9467 7.99302C11.9467 8.96518 11.5609 9.89763 10.8742 10.5857L5.7595 15.701C5.61964 15.841 5.44142 15.9363 5.24738 15.9749C5.05334 16.0135 4.8522 15.9937 4.66942 15.918C4.48664 15.8423 4.33042 15.714 4.22055 15.5495C4.11067 15.385 4.05207 15.1915 4.05216 14.9937Z"
                    fill="#4FA935" />
                </svg>
              </div>
              <div class="plano-preco">
                <div class="preco-de">
                  <span class="preco-original">De: R$49,90</span>
                  <span class="badge-desconto">15% off</span>
                </div>
                <div class="preco-valor">
                  <span class="preco-cifrao">R$</span><span class="preco-numero">29</span><span
                    class="preco-centavos">,90/mês</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Mobile: carrossel de planos -->
        <div class="planos-swiper">
          <swiper :slides-per-view="1.15" :space-between="12" :pagination="true" :centered-slides="true"
            :initial-slide="initialSlide" class="swiper-plans-container" @swiper="onSwiperInit">
            <!-- Basic -->
            <swiper-slide>
              <div class="plano-wrapper">
                <div class="badge-espaco"></div>
                <div class="plano-card" :class="{ selecionado: planSelecionado === 'basic' }"
                  @click="selecionarPlano('basic')">
                  <div class="plano-topo">
                    <div class="checkbox-icone">
                      <svg v-if="planSelecionado === 'basic'" width="40" height="40" viewBox="0 0 38 38" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="38" height="38" rx="8" fill="#A6E894" />
                        <path
                          d="M14.395 28.5C13.6569 28.5003 12.9491 28.2034 12.4277 27.6746L6.47998 21.656C5.84001 21.0079 5.84001 19.9574 6.47998 19.3093C7.12016 18.6615 8.1579 18.6615 8.79808 19.3093L14.395 24.9751L29.2019 9.98589C29.8421 9.33804 30.8798 9.33804 31.52 9.98589C32.16 10.6339 32.16 11.6845 31.52 12.3325L16.3622 27.6746C15.8408 28.2034 15.133 28.5003 14.395 28.5Z"
                          fill="#4FA935" />
                      </svg>
                      <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="38" height="38" rx="7" stroke="#D1D5DC" stroke-width="2" />
                      </svg>
                    </div>
                    <div class="plano-info">
                      <span class="plano-tipo-label">Registro</span>
                      <span class="plano-nome">Basic</span>
                    </div>
                  </div>
                  <p class="plano-descricao">No plano <strong class="destaque-plano">Basic</strong> você tem:</p>
                  <ul class="features-list">
                    <li v-for="f in planos.basic.features" :key="f">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17L4 12" stroke="#4FA935" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                      {{ f }}
                    </li>
                  </ul>
                  <div class="plano-beneficios" @click.stop="abrirModal('basic')">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.6667 5.83333H15.2183C15.6895 5.418 16.0635 4.90407 16.3138 4.328C16.5641 3.75193 16.6846 3.12784 16.6667 2.5C16.6667 2.27899 16.5789 2.06702 16.4226 1.91074C16.2663 1.75446 16.0543 1.66667 15.8333 1.66667C15.6123 1.66667 15.4004 1.75446 15.2441 1.91074C15.0878 2.06702 15 2.27899 15 2.5C15 4.685 13.0242 5.44167 11.5217 5.70083C12.0762 4.71755 12.4101 3.62531 12.5 2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5C7.58992 3.62531 7.92376 4.71755 8.47833 5.70083C6.97583 5.44167 5 4.685 5 2.5C5 2.27899 4.9122 2.06702 4.75592 1.91074C4.59964 1.75446 4.38768 1.66667 4.16667 1.66667C3.94565 1.66667 3.73369 1.75446 3.57741 1.91074C3.42113 2.06702 3.33333 2.27899 3.33333 2.5C3.31543 3.12784 3.4359 3.75193 3.6862 4.328C3.9365 4.90407 4.3105 5.418 4.78167 5.83333H3.33333C2.44928 5.83333 1.60143 6.18452 0.976311 6.80964C0.35119 7.43476 0 8.28261 0 9.16667L0 10C0 10.442 0.175595 10.8659 0.488155 11.1785C0.800716 11.4911 1.22464 11.6667 1.66667 11.6667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H14.1667C15.2713 19.9987 16.3304 19.5593 17.1115 18.7782C17.8926 17.997 18.332 16.938 18.3333 15.8333V11.6667C18.7754 11.6667 19.1993 11.4911 19.5118 11.1785C19.8244 10.8659 20 10.442 20 10V9.16667C20 8.28261 19.6488 7.43476 19.0237 6.80964C18.3986 6.18452 17.5507 5.83333 16.6667 5.83333ZM10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5C10.7327 3.38569 10.4489 4.24076 10 5.01083C9.55106 4.24076 9.26726 3.38569 9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56702 1.75446 9.77899 1.66667 10 1.66667ZM1.66667 9.16667C1.66667 8.72464 1.84226 8.30072 2.15482 7.98816C2.46738 7.67559 2.89131 7.5 3.33333 7.5H9.16667V10H1.66667V9.16667ZM3.33333 15.8333V11.6667H9.16667V18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333ZM16.6667 15.8333C16.6667 16.4964 16.4033 17.1323 15.9344 17.6011C15.4656 18.0699 14.8297 18.3333 14.1667 18.3333H10.8333V11.6667H16.6667V15.8333ZM10.8333 10V7.5H16.6667C17.1087 7.5 17.5326 7.67559 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V10H10.8333Z"
                        fill="#4FA935" />
                    </svg>
                    <span>Confira os benefícios</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05216 14.9937C4.05199 14.8624 4.07782 14.7323 4.12816 14.611C4.17851 14.4897 4.25237 14.3796 4.3455 14.287L9.46016 9.17169C9.61497 9.01692 9.73778 8.83317 9.82156 8.63093C9.90535 8.42869 9.94847 8.21193 9.94847 7.99302C9.94847 7.77411 9.90535 7.55735 9.82156 7.35511C9.73778 7.15287 9.61497 6.96912 9.46016 6.81435L4.35216 1.70702C4.25665 1.61477 4.18047 1.50443 4.12806 1.38242C4.07565 1.26042 4.04807 1.1292 4.04691 0.996422C4.04576 0.863642 4.07106 0.731962 4.12134 0.609066C4.17162 0.486169 4.24588 0.374517 4.33977 0.280625C4.43366 0.186732 4.54531 0.112479 4.66821 0.0621986C4.79111 0.0119171 4.92278 -0.0133839 5.05556 -0.0122299C5.18834 -0.011076 5.31956 0.0165091 5.44157 0.0689182C5.56357 0.121327 5.67392 0.197509 5.76616 0.293019L10.8742 5.40035C11.5609 6.08841 11.9467 7.02086 11.9467 7.99302C11.9467 8.96518 11.5609 9.89763 10.8742 10.5857L5.7595 15.701C5.61964 15.841 5.44142 15.9363 5.24738 15.9749C5.05334 16.0135 4.8522 15.9937 4.66942 15.918C4.48664 15.8423 4.33042 15.714 4.22055 15.5495C4.11067 15.385 4.05207 15.1915 4.05216 14.9937Z"
                        fill="#4FA935" />
                    </svg>
                  </div>
                  <div class="plano-preco">
                    <span class="preco-gratuito">Gratuito</span>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <!-- Starter -->
            <swiper-slide>
              <div class="plano-wrapper">
                <div class="badge-destaque">Mais popular</div>
                <div class="plano-card plano-card--destaque" :class="{ selecionado: planSelecionado === 'starter' }"
                  @click="selecionarPlano('starter')">
                  <div class="plano-topo">
                    <div class="checkbox-icone">
                      <svg v-if="planSelecionado === 'starter'" width="40" height="40" viewBox="0 0 38 38" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="38" height="38" rx="8" fill="#A6E894" />
                        <path
                          d="M14.395 28.5C13.6569 28.5003 12.9491 28.2034 12.4277 27.6746L6.47998 21.656C5.84001 21.0079 5.84001 19.9574 6.47998 19.3093C7.12016 18.6615 8.1579 18.6615 8.79808 19.3093L14.395 24.9751L29.2019 9.98589C29.8421 9.33804 30.8798 9.33804 31.52 9.98589C32.16 10.6339 32.16 11.6845 31.52 12.3325L16.3622 27.6746C15.8408 28.2034 15.133 28.5003 14.395 28.5Z"
                          fill="#4FA935" />
                      </svg>
                      <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="38" height="38" rx="7" stroke="#D1D5DC" stroke-width="2" />
                      </svg>
                    </div>
                    <div class="plano-info">
                      <span class="plano-tipo-label">Registro</span>
                      <span class="plano-nome">Starter</span>
                    </div>
                  </div>
                  <p class="plano-descricao">Tenha tudo do <strong class="destaque-plano">Basic</strong> e mais:</p>
                  <ul class="features-list features-list--2col">
                    <li v-for="f in planos.starter.features" :key="f">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17L4 12" stroke="#4FA935" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                      {{ f }}
                    </li>
                  </ul>
                  <div class="plano-beneficios" @click.stop="abrirModal('starter')">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.6667 5.83333H15.2183C15.6895 5.418 16.0635 4.90407 16.3138 4.328C16.5641 3.75193 16.6846 3.12784 16.6667 2.5C16.6667 2.27899 16.5789 2.06702 16.4226 1.91074C16.2663 1.75446 16.0543 1.66667 15.8333 1.66667C15.6123 1.66667 15.4004 1.75446 15.2441 1.91074C15.0878 2.06702 15 2.27899 15 2.5C15 4.685 13.0242 5.44167 11.5217 5.70083C12.0762 4.71755 12.4101 3.62531 12.5 2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5C7.58992 3.62531 7.92376 4.71755 8.47833 5.70083C6.97583 5.44167 5 4.685 5 2.5C5 2.27899 4.9122 2.06702 4.75592 1.91074C4.59964 1.75446 4.38768 1.66667 4.16667 1.66667C3.94565 1.66667 3.73369 1.75446 3.57741 1.91074C3.42113 2.06702 3.33333 2.27899 3.33333 2.5C3.31543 3.12784 3.4359 3.75193 3.6862 4.328C3.9365 4.90407 4.3105 5.418 4.78167 5.83333H3.33333C2.44928 5.83333 1.60143 6.18452 0.976311 6.80964C0.35119 7.43476 0 8.28261 0 9.16667L0 10C0 10.442 0.175595 10.8659 0.488155 11.1785C0.800716 11.4911 1.22464 11.6667 1.66667 11.6667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H14.1667C15.2713 19.9987 16.3304 19.5593 17.1115 18.7782C17.8926 17.997 18.332 16.938 18.3333 15.8333V11.6667C18.7754 11.6667 19.1993 11.4911 19.5118 11.1785C19.8244 10.8659 20 10.442 20 10V9.16667C20 8.28261 19.6488 7.43476 19.0237 6.80964C18.3986 6.18452 17.5507 5.83333 16.6667 5.83333ZM10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5C10.7327 3.38569 10.4489 4.24076 10 5.01083C9.55106 4.24076 9.26726 3.38569 9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56702 1.75446 9.77899 1.66667 10 1.66667ZM1.66667 9.16667C1.66667 8.72464 1.84226 8.30072 2.15482 7.98816C2.46738 7.67559 2.89131 7.5 3.33333 7.5H9.16667V10H1.66667V9.16667ZM3.33333 15.8333V11.6667H9.16667V18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333ZM16.6667 15.8333C16.6667 16.4964 16.4033 17.1323 15.9344 17.6011C15.4656 18.0699 14.8297 18.3333 14.1667 18.3333H10.8333V11.6667H16.6667V15.8333ZM10.8333 10V7.5H16.6667C17.1087 7.5 17.5326 7.67559 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V10H10.8333Z"
                        fill="#4FA935" />
                    </svg>
                    <span>Confira os benefícios</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05216 14.9937C4.05199 14.8624 4.07782 14.7323 4.12816 14.611C4.17851 14.4897 4.25237 14.3796 4.3455 14.287L9.46016 9.17169C9.61497 9.01692 9.73778 8.83317 9.82156 8.63093C9.90535 8.42869 9.94847 8.21193 9.94847 7.99302C9.94847 7.77411 9.90535 7.55735 9.82156 7.35511C9.73778 7.15287 9.61497 6.96912 9.46016 6.81435L4.35216 1.70702C4.25665 1.61477 4.18047 1.50443 4.12806 1.38242C4.07565 1.26042 4.04807 1.1292 4.04691 0.996422C4.04576 0.863642 4.07106 0.731962 4.12134 0.609066C4.17162 0.486169 4.24588 0.374517 4.33977 0.280625C4.43366 0.186732 4.54531 0.112479 4.66821 0.0621986C4.79111 0.0119171 4.92278 -0.0133839 5.05556 -0.0122299C5.18834 -0.011076 5.31956 0.0165091 5.44157 0.0689182C5.56357 0.121327 5.67392 0.197509 5.76616 0.293019L10.8742 5.40035C11.5609 6.08841 11.9467 7.02086 11.9467 7.99302C11.9467 8.96518 11.5609 9.89763 10.8742 10.5857L5.7595 15.701C5.61964 15.841 5.44142 15.9363 5.24738 15.9749C5.05334 16.0135 4.8522 15.9937 4.66942 15.918C4.48664 15.8423 4.33042 15.714 4.22055 15.5495C4.11067 15.385 4.05207 15.1915 4.05216 14.9937Z"
                        fill="#4FA935" />
                    </svg>
                  </div>
                  <div class="plano-preco">
                    <div class="preco-de">
                      <span class="preco-original">De: R$19,90</span>
                      <span class="badge-desconto">15% off</span>
                    </div>
                    <div class="preco-valor">
                      <span class="preco-cifrao">R$</span><span class="preco-numero">9</span><span
                        class="preco-centavos">,90/mês</span>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <!-- Premium -->
            <swiper-slide>
              <div class="plano-wrapper">
                <div class="badge-destaque">Mais benéfico</div>
                <div class="plano-card plano-card--destaque" :class="{ selecionado: planSelecionado === 'premium' }"
                  @click="selecionarPlano('premium')">
                  <div class="plano-topo">
                    <div class="checkbox-icone">
                      <svg v-if="planSelecionado === 'premium'" width="40" height="40" viewBox="0 0 38 38" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="38" height="38" rx="8" fill="#A6E894" />
                        <path
                          d="M14.395 28.5C13.6569 28.5003 12.9491 28.2034 12.4277 27.6746L6.47998 21.656C5.84001 21.0079 5.84001 19.9574 6.47998 19.3093C7.12016 18.6615 8.1579 18.6615 8.79808 19.3093L14.395 24.9751L29.2019 9.98589C29.8421 9.33804 30.8798 9.33804 31.52 9.98589C32.16 10.6339 32.16 11.6845 31.52 12.3325L16.3622 27.6746C15.8408 28.2034 15.133 28.5003 14.395 28.5Z"
                          fill="#4FA935" />
                      </svg>
                      <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="38" height="38" rx="7" stroke="#D1D5DC" stroke-width="2" />
                      </svg>
                    </div>
                    <div class="plano-info">
                      <span class="plano-tipo-label">Registro</span>
                      <span class="plano-nome">Premium</span>
                    </div>
                  </div>
                  <p class="plano-descricao">Tenha tudo do <strong class="destaque-plano">Starter</strong> e mais:</p>
                  <ul class="features-list features-list--2col">
                    <li v-for="f in planos.premium.features" :key="f">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17L4 12" stroke="#4FA935" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                      {{ f }}
                    </li>
                  </ul>
                  <div class="plano-beneficios" @click.stop="abrirModal('premium')">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.6667 5.83333H15.2183C15.6895 5.418 16.0635 4.90407 16.3138 4.328C16.5641 3.75193 16.6846 3.12784 16.6667 2.5C16.6667 2.27899 16.5789 2.06702 16.4226 1.91074C16.2663 1.75446 16.0543 1.66667 15.8333 1.66667C15.6123 1.66667 15.4004 1.75446 15.2441 1.91074C15.0878 2.06702 15 2.27899 15 2.5C15 4.685 13.0242 5.44167 11.5217 5.70083C12.0762 4.71755 12.4101 3.62531 12.5 2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5C7.58992 3.62531 7.92376 4.71755 8.47833 5.70083C6.97583 5.44167 5 4.685 5 2.5C5 2.27899 4.9122 2.06702 4.75592 1.91074C4.59964 1.75446 4.38768 1.66667 4.16667 1.66667C3.94565 1.66667 3.73369 1.75446 3.57741 1.91074C3.42113 2.06702 3.33333 2.27899 3.33333 2.5C3.31543 3.12784 3.4359 3.75193 3.6862 4.328C3.9365 4.90407 4.3105 5.418 4.78167 5.83333H3.33333C2.44928 5.83333 1.60143 6.18452 0.976311 6.80964C0.35119 7.43476 0 8.28261 0 9.16667L0 10C0 10.442 0.175595 10.8659 0.488155 11.1785C0.800716 11.4911 1.22464 11.6667 1.66667 11.6667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H14.1667C15.2713 19.9987 16.3304 19.5593 17.1115 18.7782C17.8926 17.997 18.332 16.938 18.3333 15.8333V11.6667C18.7754 11.6667 19.1993 11.4911 19.5118 11.1785C19.8244 10.8659 20 10.442 20 10V9.16667C20 8.28261 19.6488 7.43476 19.0237 6.80964C18.3986 6.18452 17.5507 5.83333 16.6667 5.83333ZM10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5C10.7327 3.38569 10.4489 4.24076 10 5.01083C9.55106 4.24076 9.26726 3.38569 9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56702 1.75446 9.77899 1.66667 10 1.66667ZM1.66667 9.16667C1.66667 8.72464 1.84226 8.30072 2.15482 7.98816C2.46738 7.67559 2.89131 7.5 3.33333 7.5H9.16667V10H1.66667V9.16667ZM3.33333 15.8333V11.6667H9.16667V18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333ZM16.6667 15.8333C16.6667 16.4964 16.4033 17.1323 15.9344 17.6011C15.4656 18.0699 14.8297 18.3333 14.1667 18.3333H10.8333V11.6667H16.6667V15.8333ZM10.8333 10V7.5H16.6667C17.1087 7.5 17.5326 7.67559 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V10H10.8333Z"
                        fill="#4FA935" />
                    </svg>
                    <span>Confira os benefícios</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05216 14.9937C4.05199 14.8624 4.07782 14.7323 4.12816 14.611C4.17851 14.4897 4.25237 14.3796 4.3455 14.287L9.46016 9.17169C9.61497 9.01692 9.73778 8.83317 9.82156 8.63093C9.90535 8.42869 9.94847 8.21193 9.94847 7.99302C9.94847 7.77411 9.90535 7.55735 9.82156 7.35511C9.73778 7.15287 9.61497 6.96912 9.46016 6.81435L4.35216 1.70702C4.25665 1.61477 4.18047 1.50443 4.12806 1.38242C4.07565 1.26042 4.04807 1.1292 4.04691 0.996422C4.04576 0.863642 4.07106 0.731962 4.12134 0.609066C4.17162 0.486169 4.24588 0.374517 4.33977 0.280625C4.43366 0.186732 4.54531 0.112479 4.66821 0.0621986C4.79111 0.0119171 4.92278 -0.0133839 5.05556 -0.0122299C5.18834 -0.011076 5.31956 0.0165091 5.44157 0.0689182C5.56357 0.121327 5.67392 0.197509 5.76616 0.293019L10.8742 5.40035C11.5609 6.08841 11.9467 7.02086 11.9467 7.99302C11.9467 8.96518 11.5609 9.89763 10.8742 10.5857L5.7595 15.701C5.61964 15.841 5.44142 15.9363 5.24738 15.9749C5.05334 16.0135 4.8522 15.9937 4.66942 15.918C4.48664 15.8423 4.33042 15.714 4.22055 15.5495C4.11067 15.385 4.05207 15.1915 4.05216 14.9937Z"
                        fill="#4FA935" />
                    </svg>
                  </div>
                  <div class="plano-preco">
                    <div class="preco-de">
                      <span class="preco-original">De: R$49,90</span>
                      <span class="badge-desconto">15% off</span>
                    </div>
                    <div class="preco-valor">
                      <span class="preco-cifrao">R$</span><span class="preco-numero">29</span><span
                        class="preco-centavos">,90/mês</span>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

          </swiper>
        </div>

        <p v-if="erroApi" class="campo-erro" style="text-align:center">{{ erroApi }}</p>

        <div class="rodape-form">
          <button class="btn-voltar" :disabled="carregando" @click="voltar">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5017 6.66829H0.835041M0.835041 6.66829L6.66837 0.834961M0.835041 6.66829L6.66837 12.5016"
                stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Voltar
          </button>
          <button class="btn-continuar" :disabled="!planSelecionado || carregando" @click="continuar">
            <span v-if="carregando">Aguarde...</span>
            <template v-else>
              Continuar
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                style="transform:scaleX(-1)">
                <path d="M12.5017 6.66829H0.835041M0.835041 6.66829L6.66837 0.834961M0.835041 6.66829L6.66837 12.5016"
                  stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </template>
          </button>
        </div>
      </div><!-- /.page-content -->
    </div>

    <!-- Modal benefícios -->
    <div v-if="modalAberto" class="beneficios-overlay" @click="fecharModal">
      <div class="beneficios-card" @click.stop>
        <div class="beneficios-header">
          <div>
            <h3 class="modal-titulo">Registro <span class="modal-plano-nome">{{ modalPlanoNome }}</span></h3>
            <p class="modal-subtitulo">Confira todos os benefícios do plano</p>
          </div>
          <button class="modal-fechar" @click="fecharModal">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="#425994" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <div class="beneficios-scroll">
          <ul class="modal-lista">
            <li v-for="b in modalBeneficios" :key="b.nome" class="modal-item" @click="toggleItem(b.nome)">
              <span class="modal-icone" v-html="b.icone"></span>
              <div class="modal-item-texto">
                <div class="modal-item-header">
                  <span class="modal-item-nome">{{ b.nome }}</span>
                  <span class="modal-item-chevron" :class="{ expandido: expandidoItem === b.nome }">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.25 10.957C13.1515 10.9571 13.054 10.9377 12.9631 10.9C12.8721 10.8623 12.7896 10.8069 12.7202 10.7371L8.88521 6.9026C8.76918 6.78654 8.63142 6.69447 8.4798 6.63165C8.32818 6.56884 8.16568 6.53651 8.00156 6.53651C7.83745 6.53651 7.67494 6.56884 7.52332 6.63165C7.37171 6.69447 7.23395 6.78654 7.11792 6.9026L3.28895 10.7321C3.21979 10.8037 3.13707 10.8608 3.0456 10.9001C2.95413 10.9394 2.85576 10.96 2.75621 10.9609C2.65667 10.9618 2.55795 10.9428 2.46581 10.9051C2.37368 10.8674 2.28997 10.8117 2.21958 10.7414C2.14919 10.671 2.09352 10.5873 2.05583 10.4951C2.01813 10.403 1.99916 10.3043 2.00003 10.2047C2.00089 10.1052 2.02157 10.0068 2.06087 9.91534C2.10016 9.82387 2.15727 9.74115 2.22887 9.67199L6.05784 5.84252C6.57368 5.32764 7.27273 5.03847 8.00156 5.03847C8.73039 5.03847 9.42944 5.32764 9.94528 5.84252L13.7802 9.67699C13.8852 9.78183 13.9566 9.91545 13.9856 10.0609C14.0145 10.2064 13.9997 10.3572 13.9429 10.4942C13.8861 10.6312 13.79 10.7484 13.6666 10.8307C13.5433 10.9131 13.3983 10.957 13.25 10.957Z"
                        fill="#425994" />
                    </svg>
                  </span>
                </div>
                <div v-if="expandidoItem === b.nome && b.descricao" class="modal-item-desc" v-html="b.descricao"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal upsell plano gratuito -->
    <div v-if="upsellAberto" class="upsell-overlay" @click="fecharUpsell">
      <div class="upsell-card" @click.stop>
        <button class="upsell-fechar" @click="fecharUpsell">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="#425994" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
        <img src="/img/festa-presente.svg" alt="" class="upsell-imagem" />
        <div class="upsell-corpo">
          <h3 class="upsell-titulo">Você quer perder estes benefícios <span class="upsell-nome">{{ primeiroNome
              }}</span>?
          </h3>
          <p class="upsell-subtitulo">Por apenas <strong>0,33 centavos por dia</strong>, você garante benefícios,
            praticidade e vantagens únicas para sua bike!</p>
          <ul class="upsell-lista">
            <li
              v-for="nome in ['Certificado de transferência', 'Selo de identificação', 'Reboque da bike', 'Assistência 24h', 'Transporte ciclista', 'Documento digital']"
              :key="nome">
              <span class="upsell-icone" v-html="icones[nome]"></span>
              {{ nome }}
            </li>
          </ul>
          <div class="upsell-botoes">
            <button class="btn-eu-quero" @click="irParaPremiumViaSwiper">Eu quero</button>
            <button class="btn-perder" :disabled="carregando" @click="confirmarGratuito">
              {{ carregando ? 'Aguarde...' : 'Perder benefícios' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer">
      <span>Copyright © 2025 Bike Registrada Online LTDA.</span>
      <div class="footer-contatos">
        <span>Contatos:</span>
        <a href="https://wa.me/556135224521" target="_blank" rel="noopener">
          <i class="fab fa-whatsapp"></i> (61) 3522-4521
        </a>
        <a href="mailto:seguro@bikeregistrada.com.br">
          <i class="far fa-envelope"></i> seguro@bikeregistrada.com.br
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";
import auth from "@/auth";
import RegistroBikeStepper from "@/components/RegistroBikeStepper.vue";
import { Navigation, Pagination } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination])

const ICONES = {
  'Registro da bike': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#rdb)"><path d="M19.535 3.12202L17.879 1.46402C17.4157 0.998333 16.8646 0.629159 16.2576 0.377864C15.6507 0.126569 14.9999 -0.00185599 14.343 2.02654e-05H8C6.67441 0.00160812 5.40356 0.528902 4.46622 1.46624C3.52888 2.40358 3.00159 3.67443 3 5.00002V19C3.00159 20.3256 3.52888 21.5965 4.46622 22.5338C5.40356 23.4711 6.67441 23.9984 8 24H16C17.3256 23.9984 18.5964 23.4711 19.5338 22.5338C20.4711 21.5965 20.9984 20.3256 21 19V6.65702C21.0016 6.0002 20.873 5.34959 20.6215 4.74281C20.37 4.13604 20.0007 3.58515 19.535 3.12202ZM18.121 4.53602C18.2628 4.67734 18.3898 4.83282 18.5 5.00002H16V2.50002C16.1669 2.61134 16.3227 2.7386 16.465 2.88002L18.121 4.53602ZM19 19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.684 16.7956 22 16 22H8C7.20435 22 6.44129 21.684 5.87868 21.1213C5.31607 20.5587 5 19.7957 5 19V5.00002C5 4.20437 5.31607 3.44131 5.87868 2.8787C6.44129 2.31609 7.20435 2.00002 8 2.00002H14V5.00002C14 5.53045 14.2107 6.03916 14.5858 6.41423C14.9609 6.78931 15.4696 7.00002 16 7.00002H19V19ZM16 9.00002C16.2652 9.00002 16.5196 9.10538 16.7071 9.29291C16.8946 9.48045 17 9.73481 17 10C17 10.2652 16.8946 10.5196 16.7071 10.7071C16.5196 10.8947 16.2652 11 16 11H8C7.73478 11 7.48043 10.8947 7.29289 10.7071C7.10536 10.5196 7 10.2652 7 10C7 9.73481 7.10536 9.48045 7.29289 9.29291C7.48043 9.10538 7.73478 9.00002 8 9.00002H16ZM17 14C17 14.2652 16.8946 14.5196 16.7071 14.7071C16.5196 14.8947 16.2652 15 16 15H8C7.73478 15 7.48043 14.8947 7.29289 14.7071C7.10536 14.5196 7 14.2652 7 14C7 13.7348 7.10536 13.4805 7.29289 13.2929C7.48043 13.1054 7.73478 13 8 13H16C16.2652 13 16.5196 13.1054 16.7071 13.2929C16.8946 13.4805 17 13.7348 17 14ZM16.808 17.413C16.9634 17.6269 17.0279 17.8936 16.9872 18.1548C16.9466 18.416 16.8041 18.6505 16.591 18.807C15.5778 19.529 14.3778 19.9432 13.135 20C12.4089 19.9965 11.7048 19.7501 11.135 19.3C10.807 19.075 10.682 19 10.435 19C9.76643 19.1035 9.13562 19.3769 8.603 19.794C8.39175 19.9446 8.13024 20.0072 7.87369 19.9686C7.61715 19.93 7.38565 19.7932 7.22808 19.5871C7.07052 19.381 6.99922 19.1217 7.02925 18.864C7.05927 18.6063 7.18827 18.3704 7.389 18.206C8.27018 17.522 9.32828 17.1036 10.439 17C11.1051 17.0107 11.7491 17.2409 12.271 17.655C12.5089 17.869 12.8152 17.9913 13.135 18C13.9527 17.9388 14.739 17.6594 15.412 17.191C15.6266 17.0355 15.8942 16.9715 16.1559 17.0131C16.4177 17.0547 16.6522 17.1986 16.808 17.413Z" fill="#4FA935"/></g><defs><clipPath id="rdb"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
  'Certificado de transferência': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 7V17C24 18.219 23.556 19.394 22.75 20.307C22.383 20.723 21.751 20.76 21.339 20.395C20.924 20.029 20.885 19.397 21.25 18.983C21.733 18.435 22 17.731 22 16.999V7C22 5.346 20.654 4 19 4H5C3.346 4 2 5.346 2 7V17C2 18.654 3.346 20 5 20H11C11.553 20 12 20.448 12 21C12 21.552 11.553 22 11 22H5C2.243 22 0 19.757 0 17V7C0 4.243 2.243 2 5 2H19C21.757 2 24 4.243 24 7ZM6 9H18C18.553 9 19 8.552 19 8C19 7.448 18.553 7 18 7H6C5.447 7 5 7.448 5 8C5 8.552 5.447 9 6 9ZM20.5 16C20.5 17.255 19.907 18.363 19 19.097V23.347C19 23.97 18.209 24.237 17.831 23.742L16.5 21.999L15.169 23.742C14.791 24.237 14 23.97 14 23.347V19.097C13.093 18.363 12.5 17.255 12.5 16C12.5 13.794 14.294 12 16.5 12C18.706 12 20.5 13.794 20.5 16ZM14.5 16C14.5 17.103 15.397 18 16.5 18C17.603 18 18.5 17.103 18.5 16C18.5 14.897 17.603 14 16.5 14C15.397 14 14.5 14.897 14.5 16ZM12 12C12 11.448 11.553 11 11 11H6C5.447 11 5 11.448 5 12C5 12.552 5.447 13 6 13H11C11.553 13 12 12.552 12 12ZM6 15C5.447 15 5 15.448 5 16C5 16.552 5.447 17 6 17H9C9.553 17 10 16.552 10 16C10 15.448 9.553 15 9 15H6Z" fill="#4FA935"/></svg>',
  'Reboque da bike': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#reb)"><path d="M19 6H17C15.897 6 15 6.897 15 8V12H13.968L4.268 0.36C4.078 0.132 3.797 0 3.5 0H3C2.448 0 2 0.448 2 1V6.5C2 6.776 1.776 7 1.5 7H1C0.448 7 0 7.448 0 8C0 8.552 0.448 9 1 9H1.5C2.878 9 4 7.878 4 6.5V3.162L11.365 12H3C1.346 12 0 13.346 0 15V17C0 18.654 1.346 20 3 20H3.037C3.013 20.165 3 20.331 3 20.5C3 22.43 4.57 24 6.5 24C8.43 24 10 22.43 10 20.5C10 20.331 9.987 20.165 9.963 20H14.037C14.013 20.165 14 20.331 14 20.5C14 22.43 15.57 24 17.5 24C19.43 24 21 22.43 21 20.5C21 20.293 20.981 20.088 20.945 19.887C22.696 19.461 24 17.88 24 16V11C24 8.243 21.757 6 19 6ZM19 8C20.654 8 22 9.346 22 11V12H17V8H19ZM2 17V15C2 14.449 2.449 14 3 14H15V18H8.493C8.488 18 8.483 18 8.477 18H4.529C4.519 18 4.508 18 4.498 18H3C2.449 18 2 17.551 2 17ZM8 20.5C8 21.327 7.327 22 6.5 22C5.673 22 5 21.327 5 20.5C5 20.311 5.037 20.144 5.091 20H7.91C7.964 20.144 8.001 20.311 8.001 20.5H8ZM17.5 22C16.673 22 16 21.327 16 20.5C16 20.311 16.037 20.144 16.091 20H18.91C18.964 20.144 19.001 20.311 19.001 20.5C19.001 21.327 18.327 22 17.5 22ZM20 18H19.493C19.488 18 19.483 18 19.477 18H17V14H22V16C22 17.103 21.103 18 20 18Z" fill="#4FA935"/></g><defs><clipPath id="reb"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
  'Assistência 24h': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a24)"><path d="M13.0005 0.999644C13.0005 0.734427 13.1058 0.480073 13.2934 0.292537C13.4809 0.105001 13.7353 -0.000356157 14.0005 -0.000356157C16.6517 0.00255544 19.1936 1.05706 21.0683 2.93179C22.9431 4.80653 23.9976 7.34837 24.0005 9.99965C24.0005 10.2649 23.8951 10.5192 23.7076 10.7068C23.52 10.8943 23.2657 10.9996 23.0005 10.9996C22.7353 10.9996 22.4809 10.8943 22.2934 10.7068C22.1058 10.5192 22.0005 10.2649 22.0005 9.99965C21.9981 7.87864 21.1545 5.8452 19.6547 4.34542C18.1549 2.84565 16.1215 2.00203 14.0005 1.99964C13.7353 1.99964 13.4809 1.89429 13.2934 1.70675C13.1058 1.51921 13.0005 1.26486 13.0005 0.999644ZM14.0005 5.99964C15.0613 5.99964 16.0788 6.42107 16.8289 7.17122C17.579 7.92136 18.0005 8.93878 18.0005 9.99965C18.0005 10.2649 18.1058 10.5192 18.2934 10.7068C18.4809 10.8943 18.7353 10.9996 19.0005 10.9996C19.2657 10.9996 19.52 10.8943 19.7076 10.7068C19.8951 10.5192 20.0005 10.2649 20.0005 9.99965C19.9989 8.40883 19.3662 6.88363 18.2414 5.75876C17.1165 4.63388 15.5913 4.00123 14.0005 3.99964C13.7353 3.99964 13.4809 4.105 13.2934 4.29254C13.1058 4.48007 13.0005 4.73443 13.0005 4.99964C13.0005 5.26486 13.1058 5.51921 13.2934 5.70675C13.4809 5.89429 13.7353 5.99964 14.0005 5.99964ZM23.0935 16.7386C23.673 17.3198 23.9984 18.107 23.9984 18.9276C23.9984 19.7483 23.673 20.5355 23.0935 21.1166L22.1835 22.1656C13.9935 30.0066 -5.93653 10.0816 1.78347 1.86564L2.93347 0.865644C3.51524 0.302321 4.29541 -0.00930708 5.10518 -0.00182132C5.91495 0.00566445 6.68922 0.331662 7.26047 0.905644C7.29147 0.936644 9.14447 3.34364 9.14447 3.34364C9.6943 3.92127 10.0004 4.68857 9.99907 5.48605C9.99777 6.28352 9.68919 7.04982 9.13747 7.62564L7.97947 9.08165C8.62032 10.6388 9.56254 12.0539 10.752 13.2457C11.9414 14.4376 13.3547 15.3827 14.9105 16.0266L16.3755 14.8616C16.9514 14.3104 17.7175 14.0021 18.5148 14.001C19.312 13.9999 20.079 14.306 20.6565 14.8556C20.6565 14.8556 23.0625 16.7076 23.0935 16.7386ZM21.7175 18.1926C21.7175 18.1926 19.3245 16.3516 19.2935 16.3206C19.0875 16.1164 18.8091 16.0018 18.519 16.0018C18.2289 16.0018 17.9505 16.1164 17.7445 16.3206C17.7175 16.3486 15.7005 17.9556 15.7005 17.9556C15.5646 18.0638 15.4028 18.1348 15.2311 18.1614C15.0595 18.1881 14.8838 18.1695 14.7215 18.1076C12.7059 17.3572 10.8752 16.1824 9.35331 14.6627C7.83141 13.1431 6.65388 11.3141 5.90047 9.29965C5.83367 9.1351 5.81189 8.95573 5.83738 8.77998C5.86286 8.60423 5.93469 8.43844 6.04547 8.29965C6.04547 8.29965 7.65247 6.28164 7.67947 6.25564C7.88374 6.04963 7.99835 5.77126 7.99835 5.48114C7.99835 5.19103 7.88374 4.91266 7.67947 4.70664C7.64847 4.67664 5.80747 2.28164 5.80747 2.28164C5.59837 2.09415 5.32548 1.99374 5.04472 2.00099C4.76397 2.00824 4.49662 2.12261 4.29747 2.32064L3.14747 3.32064C-2.49453 10.1046 14.7765 26.4176 20.7215 20.7996L21.6325 19.7496C21.846 19.5519 21.9742 19.2789 21.99 18.9883C22.0059 18.6978 21.9082 18.4125 21.7175 18.1926Z" fill="#4FA935"/></g><defs><clipPath id="a24"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
  'Transporte ciclista': '<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 4H16.923C16.587 2.097 15.17 0.526 13.249 0.0319999C12.72 -0.105 12.17 0.217 12.031 0.751C11.893 1.286 12.216 1.831 12.751 1.968C14.075 2.309 15 3.504 15 4.874V16H4C2.897 16 2 15.103 2 14V10H4.5C5.053 10 5.5 9.552 5.5 9C5.5 8.448 5.053 8 4.5 8H2C0.897 8 0 8.897 0 10V14C0 15.88 1.304 17.461 3.055 17.887C3.019 18.088 3 18.293 3 18.5C3 20.43 4.57 22 6.5 22C8.43 22 10 20.43 10 18.5C10 18.331 9.987 18.165 9.963 18H14.037C14.013 18.165 14 18.331 14 18.5C14 20.43 15.57 22 17.5 22C19.43 22 21 20.43 21 18.5C21 18.293 20.981 18.088 20.945 17.887C22.696 17.461 24 15.88 24 14V9C24 6.243 21.757 4 19 4ZM22 9V10H17V6H19C20.654 6 22 7.346 22 9ZM8 18.5C8 19.327 7.327 20 6.5 20C5.673 20 5 19.327 5 18.5C5 18.311 5.037 18.144 5.091 18H7.91C7.964 18.144 8.001 18.311 8.001 18.5H8ZM17.5 20C16.673 20 16 19.327 16 18.5C16 18.311 16.037 18.144 16.091 18H18.91C18.964 18.144 19.001 18.311 19.001 18.5C19.001 19.327 18.327 20 17.5 20ZM20 16H17V12H22V14C22 15.103 21.103 16 20 16ZM0 1C0 0.448 0.447 0 1 0H9.154C9.707 0 10.154 0.448 10.154 1C10.154 1.552 9.707 2 9.154 2H1C0.447 2 0 1.552 0 1ZM0 5C0 4.448 0.447 4 1 4H7.154C7.707 4 8.154 4.448 8.154 5C8.154 5.552 7.707 6 7.154 6H1C0.447 6 0 5.552 0 5Z" fill="#4FA935"/></svg>',
  'Selo de identificação': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 0H4C1.794 0 0 1.794 0 4V7C0 9.206 1.794 11 4 11H7C9.206 11 11 9.206 11 7V4C11 1.794 9.206 0 7 0ZM9 7C9 8.103 8.103 9 7 9H4C2.897 9 2 8.103 2 7V4C2 2.897 2.897 2 4 2H7C8.103 2 9 2.897 9 4V7ZM7 5V6C7 6.552 6.552 7 6 7H5C4.448 7 4 6.552 4 6V5C4 4.448 4.448 4 5 4H6C6.552 4 7 4.448 7 5ZM17 11H20C22.206 11 24 9.206 24 7V4C24 1.794 22.206 0 20 0H17C14.794 0 13 1.794 13 4V7C13 9.206 14.794 11 17 11ZM15 4C15 2.897 15.897 2 17 2H20C21.103 2 22 2.897 22 4V7C22 8.103 21.103 9 20 9H17C15.897 9 15 8.103 15 7V4ZM17 6V5C17 4.448 17.448 4 18 4H19C19.552 4 20 4.448 20 5V6C20 6.552 19.552 7 19 7H18C17.448 7 17 6.552 17 6ZM7 13H4C1.794 13 0 14.794 0 17V20C0 22.206 1.794 24 4 24H7C9.206 24 11 22.206 11 20V17C11 14.794 9.206 13 7 13ZM9 20C9 21.103 8.103 22 7 22H4C2.897 22 2 21.103 2 20V17C2 15.897 2.897 15 4 15H7C8.103 15 9 15.897 9 17V20ZM7 18V19C7 19.552 6.552 20 6 20H5C4.448 20 4 19.552 4 19V18C4 17.448 4.448 17 5 17H6C6.552 17 7 17.448 7 18ZM17 14.5V15.5C17 16.328 16.328 17 15.5 17H14.5C13.672 17 13 16.328 13 15.5V14.5C13 13.672 13.672 13 14.5 13H15.5C16.328 13 17 13.672 17 14.5ZM20 18.5C20 19.328 19.328 20 18.5 20C17.672 20 17 19.328 17 18.5C17 17.672 17.672 17 18.5 17C19.328 17 20 17.672 20 18.5ZM17 21.5V22.5C17 23.328 16.328 24 15.5 24H14.5C13.672 24 13 23.328 13 22.5V21.5C13 20.672 13.672 20 14.5 20H15.5C16.328 20 17 20.672 17 21.5ZM24 14.5V15.5C24 16.328 23.328 17 22.5 17H21.5C20.672 17 20 16.328 20 15.5V14.5C20 13.672 20.672 13 21.5 13H22.5C23.328 13 24 13.672 24 14.5Z" fill="#4FA935"/></svg>',
  'Revisão da bike': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6955 11.718L9.83351 13.523C9.51551 13.841 9.09351 14.001 8.67051 14.001C8.24351 14.001 7.81451 13.838 7.48751 13.512L6.80651 12.858C6.40851 12.475 6.39551 11.842 6.77851 11.444C7.16151 11.046 7.79551 11.034 8.19251 11.416L8.66551 11.871L10.3035 10.283C10.6995 9.9 11.3325 9.908 11.7175 10.305C12.1015 10.701 12.0925 11.333 11.6955 11.718ZM15.9995 17H12.9995C12.4475 17 11.9995 17.448 11.9995 18C11.9995 18.552 12.4475 19 12.9995 19H15.9995C16.5515 19 16.9995 18.552 16.9995 18C16.9995 17.448 16.5515 17 15.9995 17ZM15.9995 5H12.9995C12.4475 5 11.9995 5.448 11.9995 6C11.9995 6.552 12.4475 7 12.9995 7H15.9995C16.5515 7 16.9995 6.552 16.9995 6C16.9995 5.448 16.5515 5 15.9995 5ZM15.9995 11H13.9995C13.4475 11 12.9995 11.448 12.9995 12C12.9995 12.552 13.4475 13 13.9995 13H15.9995C16.5515 13 16.9995 12.552 16.9995 12C16.9995 11.448 16.5515 11 15.9995 11ZM8.49951 16.5C7.67151 16.5 6.99951 17.172 6.99951 18C6.99951 18.828 7.67151 19.5 8.49951 19.5C9.32751 19.5 9.99951 18.828 9.99951 18C9.99951 17.172 9.32751 16.5 8.49951 16.5ZM8.49951 7.5C9.32751 7.5 9.99951 6.828 9.99951 6C9.99951 5.172 9.32751 4.5 8.49951 4.5C7.67151 4.5 6.99951 5.172 6.99951 6C6.99951 6.828 7.67151 7.5 8.49951 7.5ZM21.9995 5V19C21.9995 21.757 19.7565 24 16.9995 24H6.99951C4.24251 24 1.99951 21.757 1.99951 19V5C1.99951 2.243 4.24251 0 6.99951 0H16.9995C19.7565 0 21.9995 2.243 21.9995 5ZM19.9995 5C19.9995 3.346 18.6535 2 16.9995 2H6.99951C5.34551 2 3.99951 3.346 3.99951 5V19C3.99951 20.654 5.34551 22 6.99951 22H16.9995C18.6535 22 19.9995 20.654 19.9995 19V5Z" fill="#4FA935"/></svg>',
  'Consultor Bike': '<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 8H22V3C22 1.346 20.654 0 19 0C17.346 0 16 1.346 16 3V8H8V3C8 1.346 6.654 0 5 0C3.346 0 2 1.346 2 3V8H1C0.448 8 0 8.448 0 9C0 9.552 0.448 10 1 10H2V15C2 16.654 3.346 18 5 18C6.654 18 8 16.654 8 15V10H16V15C16 16.654 17.346 18 19 18C20.654 18 22 16.654 22 15V10H23C23.552 10 24 9.552 24 9C24 8.448 23.552 8 23 8ZM6 15C6 15.552 5.551 16 5 16C4.449 16 4 15.552 4 15V3C4 2.449 4.449 2 5 2C5.551 2 6 2.449 6 3V15ZM20 15C20 15.552 19.551 16 19 16C18.449 16 18 15.552 18 15V3C18 2.449 18.449 2 19 2C19.551 2 20 2.449 20 3V15Z" fill="#4FA935"/></svg>',
  'Chaveiro': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.49521 24C5.68496 23.9989 3.93622 23.343 2.57167 22.1535C1.20712 20.9639 0.318848 19.321 0.0707749 17.5278C-0.177299 15.7346 0.231563 13.9122 1.22191 12.3969C2.21226 10.8816 3.71727 9.7756 5.45921 9.28302C6.72534 8.92045 8.06551 8.90387 9.34021 9.23502L17.2482 1.32902C17.668 0.906302 18.1676 0.571153 18.7179 0.343015C19.2683 0.114877 19.8585 -0.0017098 20.4542 1.89472e-05C21.3918 0.000813379 22.2907 0.37361 22.9537 1.03657C23.6166 1.69952 23.9894 2.59846 23.9902 3.53602C23.9918 4.13181 23.8752 4.722 23.6473 5.27246C23.4193 5.82292 23.0845 6.32274 22.6622 6.74302L21.9902 7.41502C21.6142 7.78846 21.1062 7.99865 20.5762 8.00002H18.9902V9.00002C18.9902 9.53045 18.7795 10.0392 18.4044 10.4142C18.0294 10.7893 17.5206 11 16.9902 11H15.9902V12.586C15.9909 12.8488 15.9395 13.109 15.8389 13.3517C15.7383 13.5945 15.5906 13.8148 15.4042 14L14.7542 14.65C15.0872 15.9241 15.0709 17.2644 14.7072 18.53C14.2979 19.972 13.4675 21.259 12.3224 22.2262C11.1772 23.1934 9.76937 23.7968 8.27921 23.959C8.01875 23.9861 7.75707 23.9998 7.49521 24ZM7.49521 11C6.47136 10.999 5.46756 11.2838 4.5968 11.8224C3.72604 12.361 3.02289 13.1319 2.56651 14.0484C2.11013 14.9649 1.91864 15.9906 2.01359 17.0101C2.10853 18.0295 2.48615 19.0022 3.10393 19.8187C3.72171 20.6351 4.55513 21.2629 5.51037 21.6314C6.46561 21.9999 7.50474 22.0945 8.5108 21.9044C9.51686 21.7144 10.4499 21.2473 11.2049 20.5557C11.9599 19.8642 12.5068 18.9756 12.7842 17.99C13.0962 16.9066 13.0612 15.7526 12.6842 14.69C12.6227 14.5126 12.6124 14.3214 12.6545 14.1383C12.6966 13.9553 12.7893 13.7878 12.9222 13.655L13.9902 12.586V11C13.9902 10.4696 14.2009 9.96088 14.576 9.58581C14.9511 9.21073 15.4598 9.00002 15.9902 9.00002H16.9902V8.00002C16.9902 7.46959 17.2009 6.96088 17.576 6.58581C17.9511 6.21073 18.4598 6.00002 18.9902 6.00002H20.5762L21.2482 5.32802C21.4842 5.09317 21.6712 4.81388 21.7986 4.5063C21.926 4.19871 21.9911 3.86893 21.9902 3.53602C21.9899 3.1289 21.8282 2.73852 21.5404 2.45055C21.2526 2.16258 20.8623 2.00055 20.4552 2.00002C20.1221 1.9992 19.7921 2.06445 19.4843 2.19198C19.1765 2.31951 18.8971 2.5068 18.6622 2.74302L10.3312 11.073C10.1983 11.2059 10.0305 11.2986 9.8473 11.3405C9.66406 11.3825 9.47272 11.3719 9.29521 11.31C8.71528 11.1058 8.10504 11.001 7.49021 11H7.49521ZM4.99021 18C4.99021 18.1978 5.04886 18.3911 5.15874 18.5556C5.26862 18.72 5.4248 18.8482 5.60753 18.9239C5.79025 18.9996 5.99132 19.0194 6.1853 18.9808C6.37928 18.9422 6.55747 18.847 6.69732 18.7071C6.83717 18.5673 6.93241 18.3891 6.971 18.1951C7.00958 18.0011 6.98978 17.8001 6.91409 17.6173C6.8384 17.4346 6.71023 17.2784 6.54578 17.1685C6.38133 17.0587 6.18799 17 5.99021 17C5.725 17 5.47064 17.1054 5.28311 17.2929C5.09557 17.4804 4.99021 17.7348 4.99021 18Z" fill="#4FA935"/></svg>',
  'Bike box': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#bb)"><path d="M15.091 15.997C21.662 15.964 24 12.484 24 9.5C24 7.823 22.813 6.42 21.236 6.081C21.372 5.694 21.49 5.339 21.57 5.07C21.923 3.877 21.694 2.616 20.943 1.611C20.177 0.588 19.006 0 17.729 0H6.271C4.994 0 3.822 0.588 3.056 1.612C2.305 2.617 2.077 3.878 2.43 5.07C2.51 5.339 2.627 5.694 2.764 6.081C1.187 6.42 0 7.823 0 9.5C0 12.484 2.339 15.964 8.909 15.997C8.965 16.299 9 16.607 9 16.92V20C9 21.826 7.464 21.992 7 22H6C5.447 22 5 22.447 5 23C5 23.553 5.447 24 6 24H18C18.553 24 19 23.553 19 23C19 22.447 18.553 22 18 22H17.008C16.536 21.992 15 21.826 15 20V16.92C15 16.607 15.035 16.299 15.091 15.997ZM20.5 8C21.327 8 22 8.673 22 9.5C22 11.534 20.391 13.697 15.964 13.97C16.185 13.671 16.438 13.394 16.726 13.149C18.465 11.671 19.659 9.696 20.453 7.99C20.47 7.99 20.483 8 20.5 8ZM2 9.5C2 8.673 2.673 8 3.5 8C3.517 8 3.531 7.991 3.547 7.99C4.341 9.696 5.534 11.67 7.274 13.149C7.562 13.394 7.815 13.67 8.036 13.97C3.609 13.697 2 11.534 2 9.5ZM10.513 22C10.808 21.459 11 20.806 11 20V16.92C11 14.869 10.114 12.94 8.569 11.626C6.8 10.122 5.222 7.459 4.348 4.504C4.176 3.921 4.288 3.304 4.659 2.81C5.043 2.295 5.631 2 6.271 2H17.728C18.368 2 18.956 2.295 19.34 2.809C19.709 3.304 19.822 3.921 19.651 4.503C18.776 7.46 17.198 10.122 15.43 11.626C13.885 12.939 12.999 14.869 12.999 16.92V20C12.999 20.806 13.19 21.459 13.486 22H10.513ZM9.791 9.763C9.527 9.581 9.416 9.245 9.521 8.941L10.04 7.335L8.674 6.335C8.347 6.095 8.276 5.636 8.516 5.309C8.654 5.121 8.874 5.009 9.107 5.009H10.788L11.299 3.416C11.428 3.029 11.846 2.821 12.233 2.95C12.453 3.023 12.626 3.196 12.699 3.416L13.209 5.009H14.89C15.295 5.009 15.624 5.337 15.624 5.743C15.624 5.978 15.512 6.198 15.323 6.336L13.957 7.336L14.476 8.942C14.6 9.328 14.388 9.742 14.001 9.867C13.777 9.939 13.532 9.899 13.342 9.76L11.999 8.772L10.655 9.759C10.399 9.95 10.049 9.951 9.791 9.763Z" fill="#4FA935"/></g><defs><clipPath id="bb"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
  'Reparo da bike': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.6277 24.0004C3.5957 24.0004 3.5647 24.0004 3.5327 24.0004C2.5107 23.9734 1.5697 23.5384 0.883697 22.7764C-0.385303 21.3674 -0.273303 18.9924 1.1277 17.5914L6.9957 11.7244C7.2487 11.4704 7.3397 11.0934 7.2367 10.7154C6.8787 9.39741 6.8437 8.03941 7.1347 6.67941C7.8427 3.36441 10.5657 0.735407 13.9117 0.137407C14.9177 -0.0425932 15.9267 -0.0465932 16.9137 0.130407C17.6447 0.259407 18.2127 0.755407 18.4337 1.45541C18.6847 2.25441 18.4307 3.13641 17.7517 3.81441L15.5047 6.03141C14.8467 6.68941 14.7467 7.72141 15.2827 8.37641C15.5907 8.75441 16.0247 8.97441 16.5047 8.99841C16.9767 9.01841 17.4407 8.84341 17.7757 8.50941L20.3557 5.95941C20.8947 5.42041 21.6877 5.22441 22.4257 5.45841C23.1487 5.68541 23.6797 6.28641 23.8107 7.02541C23.9857 8.01241 23.9827 9.02341 23.8037 10.0284C23.2037 13.3754 20.5747 16.0984 17.2597 16.8054C15.8967 17.0964 14.5387 17.0614 13.2237 16.7024C12.8467 16.5984 12.4697 16.6904 12.2157 16.9434L6.2397 22.9184C5.5497 23.6084 4.6027 24.0004 3.6277 24.0004ZM15.5497 1.99341C15.1277 1.99341 14.6957 2.02841 14.2637 2.10541C11.7097 2.56241 9.6297 4.56841 9.0897 7.09641C8.8657 8.14141 8.8917 9.18241 9.1657 10.1894C9.4557 11.2514 9.1657 12.3804 8.4097 13.1374L2.5417 19.0044C1.8917 19.6544 1.8097 20.8144 2.3707 21.4374C2.6857 21.7874 3.1177 21.9874 3.5857 21.9994C4.0467 22.0184 4.4947 21.8364 4.8267 21.5054L10.8017 15.5304C11.5567 14.7754 12.6867 14.4834 13.7497 14.7734C14.7537 15.0474 15.7947 15.0734 16.8427 14.8494C19.3707 14.3104 21.3767 12.2314 21.8347 9.67541C21.9727 8.90341 21.9747 8.12841 21.8407 7.37441V7.36741L19.1857 9.92641C18.4567 10.6554 17.4417 11.0624 16.4047 10.9944C15.3687 10.9424 14.3957 10.4494 13.7357 9.64141C12.5567 8.20241 12.7147 5.99241 14.0967 4.61141L16.3437 2.39441C16.5227 2.21441 16.5347 2.08041 16.5277 2.05341C16.2127 2.01441 15.8847 1.99141 15.5517 1.99141L15.5497 1.99341Z" fill="#4FA935"/></svg>',
  'Nutrição esportiva': '<svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 23C20 23.552 19.553 24 19 24C18.447 24 18 23.552 18 23C18 20.215 16.361 17.811 14 16.685V19.184C15.161 19.598 16 20.698 16 22V23C16 23.552 15.553 24 15 24C14.447 24 14 23.552 14 23V22C14 21.449 13.552 21 13 21C12.448 21 12 21.449 12 22V23C12 23.552 11.553 24 11 24C10.447 24 10 23.552 10 23V22C10 20.698 10.839 19.598 12 19.184V16.08C11.672 16.033 11.34 16 11 16H9C8.305 16 7.634 16.105 7 16.295V19.278C7.595 19.624 8 20.262 8 21.001C8 22.106 7.105 23.001 6 23.001C4.895 23.001 4 22.106 4 21.001C4 20.263 4.405 19.625 5 19.278V17.264C3.189 18.531 2 20.628 2 23C2 23.552 1.553 24 1 24C0.447 24 0 23.552 0 23C0 18.038 4.037 14 9 14H11C15.963 14 20 18.038 20 23ZM1.872 12.822C2.181 11.516 3.726 4.973 3.9 4.436C4.758 1.783 7.209 0 10 0C12.791 0 15.242 1.783 16.1 4.437C16.274 4.973 17.82 11.516 18.128 12.822C18.254 13.36 17.922 13.898 17.384 14.025C16.861 14.153 16.306 13.823 16.181 13.281C15.481 10.313 14.324 5.454 14.197 5.051C13.893 4.109 13.293 3.331 12.522 2.795C11.994 4.107 11.075 5.218 9.853 5.98C8.772 6.654 7.55 7.001 6.307 7.001C6.251 7.001 6.195 6.993 6.14 6.991C6.584 8.716 8.139 10 10.001 10C10.704 10 11.396 9.815 12 9.465C12.479 9.187 13.091 9.351 13.366 9.83C13.643 10.308 13.479 10.92 13.002 11.196C12.093 11.721 11.056 11.999 10.001 11.999C7.798 11.999 5.873 10.802 4.83 9.027C4.486 10.466 4.113 12.037 3.82 13.279C3.692 13.817 3.152 14.153 2.617 14.023C2.079 13.897 1.747 13.358 1.873 12.82L1.872 12.822ZM5.842 4.958C6.872 5.059 7.901 4.84 8.794 4.283C9.65 3.749 10.286 2.969 10.657 2.053C10.442 2.021 10.223 2.001 10 2.001C8.114 2.001 6.459 3.187 5.842 4.958Z" fill="#4FA935"/></svg>',
  'Manutenção da bike': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9734 13.0244C16.8544 11.9084 15.1604 11.7064 13.8334 12.4174L9.00136 7.5854V4.4994C9.00136 3.4864 8.45636 2.5434 7.57936 2.0374L4.59836 0.3184C3.66736 -0.2196 2.48636 -0.0626001 1.72436 0.6974L0.699363 1.7244C-0.0616368 2.4834 -0.216637 3.6654 0.320363 4.5964L2.03936 7.5774C2.54536 8.4554 3.48936 9.0004 4.50136 9.0004H7.58736L12.4134 13.8264C12.1354 14.3344 11.9874 14.9054 11.9874 15.5004C11.9874 16.4364 12.3524 17.3144 13.0154 17.9764L18.0294 22.9764C18.6874 23.6324 19.5834 24.0004 20.5094 24.0004C21.4944 24.0004 22.5974 23.4794 23.2274 22.7114C24.3534 21.3394 24.2034 19.2364 22.8864 17.9244L17.9734 13.0244ZM3.77136 6.5794L2.05236 3.5974C1.96636 3.4494 1.99136 3.2604 2.11336 3.1384L3.13836 2.1124C3.26036 1.9914 3.44936 1.9654 3.59836 2.0514L6.57836 3.7714C6.83836 3.9214 7.00036 4.2014 7.00036 4.5004V7.0004H4.50036C4.20036 7.0004 3.92136 6.8394 3.77136 6.5794ZM21.6814 21.4424C21.4054 21.7794 21.0154 21.9764 20.5844 21.9984C20.1634 22.0184 19.7434 21.8594 19.4424 21.5604L14.4284 16.5604C14.1444 16.2774 13.9884 15.9014 13.9884 15.5004C13.9884 15.0994 14.1454 14.7244 14.4284 14.4404C14.7224 14.1474 15.1094 14.0004 15.4954 14.0004C15.8814 14.0004 16.2674 14.1474 16.5614 14.4404L21.4754 19.3394C22.0714 19.9344 22.1614 20.8574 21.6814 21.4424ZM10.4314 17.0994C10.8214 17.4914 10.8204 18.1234 10.4294 18.5134L5.95236 22.9754C5.29436 23.6314 4.39936 23.9994 3.47236 23.9994C2.59136 23.9994 1.38436 23.4784 0.754363 22.7094C-0.370637 21.3384 -0.221637 19.2354 1.09636 17.9234L6.76436 12.2684C7.15436 11.8784 7.78836 11.8784 8.17836 12.2704C8.56836 12.6614 8.56736 13.2944 8.17636 13.6844L2.50736 19.3394C1.91136 19.9344 1.81936 20.8574 2.29936 21.4414C2.57636 21.7794 2.96636 21.9764 3.39736 21.9984C3.82336 22.0174 4.23836 21.8594 4.53936 21.5604L9.01736 17.0984C9.40836 16.7084 10.0404 16.7084 10.4324 17.1004L10.4314 17.0994ZM9.88736 4.6344C10.8074 2.2914 12.9114 0.5604 15.3784 0.1174C16.2414 -0.0366001 17.1084 -0.0396001 17.9574 0.1114C18.6234 0.2294 19.1604 0.6994 19.3594 1.3354C19.5884 2.0644 19.3594 2.8664 18.7474 3.4804L16.4124 5.7224C15.9274 6.2074 15.8484 6.9834 16.2474 7.4714C16.4774 7.7524 16.8004 7.9164 17.1584 7.9354C17.5074 7.9524 17.8524 7.8234 18.1054 7.5704L20.7194 5.0494C21.2054 4.5634 21.9324 4.3824 22.6124 4.5994C23.2764 4.8084 23.7634 5.3614 23.8844 6.0404C24.0344 6.8884 24.0324 7.7574 23.8784 8.6214C23.5974 10.1934 22.7784 11.6574 21.5724 12.7444C21.3814 12.9164 21.1414 13.0014 20.9034 13.0014C20.6304 13.0014 20.3574 12.8904 20.1604 12.6714C19.7904 12.2614 19.8234 11.6284 20.2334 11.2584C21.1104 10.4684 21.7054 9.4064 21.9094 8.2704C22.0074 7.7224 22.0214 7.1754 21.9524 6.6384L19.5074 8.9974C18.8724 9.6344 17.9774 9.9814 17.0594 9.9334C16.1434 9.8874 15.2834 9.4524 14.6994 8.7384C13.6574 7.4644 13.7954 5.5124 15.0134 4.2954L17.3474 2.0534L17.3564 2.0444C16.8214 1.9764 16.2754 1.9904 15.7314 2.0884C13.9434 2.4084 12.4184 3.6654 11.7494 5.3674C11.5484 5.8814 10.9674 6.1344 10.4534 5.9324C9.93936 5.7304 9.68536 5.1504 9.88836 4.6364L9.88736 4.6344Z" fill="#4FA935"/></svg>',
  'Bike fit': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 14C2.243 14 0 16.243 0 19C0 21.757 2.243 24 5 24C7.757 24 10 21.757 10 19C10 16.243 7.757 14 5 14ZM5 22C3.346 22 2 20.654 2 19C2 17.346 3.346 16 5 16C6.654 16 8 17.346 8 19C8 20.654 6.654 22 5 22ZM19.24 14.024L16.977 10.364C16.849 10.151 16.984 10 17.239 10H18.999C19.551 10 19.999 9.553 19.999 9C19.999 8.447 19.551 8 18.999 8H17.325C17.159 8 16.997 8.023 16.839 8.056L13.183 6.378C11.766 5.589 9.952 6.09 9.127 7.502L7.937 9.618C7.491 10.351 7.379 11.242 7.632 12.062C7.877 12.856 8.441 13.513 9.187 13.875L10.999 15.044V18.999C10.999 19.552 11.447 19.999 11.999 19.999C12.551 19.999 12.999 19.552 12.999 18.999V15.044C12.999 14.36 12.656 13.732 12.083 13.364C12.083 13.364 10.131 12.108 10.086 12.088C9.821 11.969 9.628 11.749 9.543 11.472C9.458 11.196 9.494 10.907 9.662 10.628L10.862 8.495C11.135 8.028 11.741 7.865 12.279 8.159L15.146 9.477C14.927 10.034 14.892 10.716 15.185 11.269L17.106 14.376C15.286 15.124 13.999 16.912 13.999 18.998C13.999 21.755 16.242 23.998 18.999 23.998C21.756 23.998 23.999 21.755 23.999 18.998C23.999 16.323 21.882 14.15 19.239 14.022L19.24 14.024ZM19 22C17.346 22 16 20.654 16 19C16 17.346 17.346 16 19 16C20.654 16 22 17.346 22 19C22 20.654 20.654 22 19 22ZM11 2.5C11 1.119 12.119 0 13.5 0C14.881 0 16 1.119 16 2.5C16 3.881 14.881 5 13.5 5C12.119 5 11 3.881 11 2.5Z" fill="#4FA935"/></svg>',
  'Treino de ciclista': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12C9.309 12 12 9.309 12 6C12 2.691 9.309 0 6 0C2.691 0 0 2.691 0 6C0 9.309 2.691 12 6 12ZM6 2C8.206 2 10 3.794 10 6C10 8.206 8.206 10 6 10C3.794 10 2 8.206 2 6C2 3.794 3.794 2 6 2ZM3.693 6.208L4.601 3.615C4.744 3.244 5.1 3 5.497 3H6.251C6.653 3 6.923 3.411 6.764 3.78L6.307 5.002H7.789C8.176 5 8.41 5.43 8.198 5.754L5.571 8.83C5.489 8.936 5.363 8.999 5.229 8.999C4.933 8.999 4.723 8.71 4.817 8.429L5.293 7.001H4.29C3.875 7.003 3.575 6.604 3.693 6.206V6.208ZM19.751 14.076C18.668 10.754 18 8.069 18 7C18 6.448 18.449 6 19 6C19.551 6 20 6.448 20 7C20 7.552 20.448 8 21 8C21.552 8 22 7.553 22 7C22 5.346 20.654 4 19 4C17.346 4 16 5.346 16 7C16 7.592 16.136 8.418 16.334 9.329L11.627 12.929L11.089 12.432C10.684 12.059 10.051 12.084 9.676 12.49C9.302 12.896 9.327 13.528 9.734 13.903L10.015 14.162L8.426 15.377C7.53 14.53 6.329 14.001 5.001 14.001C2.244 14.001 0.001 16.244 0.001 19.001C0.001 21.758 2.244 24.001 5.001 24.001C7.758 24.001 10.001 21.758 10.001 19.001C10.001 18.293 9.849 17.621 9.582 17.01L16.862 11.443C17.128 12.402 17.417 13.355 17.687 14.198C15.569 14.779 14 16.701 14 19.001C14 21.758 16.243 24.001 19 24.001C21.757 24.001 24 21.758 24 19.001C24 16.501 22.15 14.442 19.751 14.076ZM5 22C3.346 22 2 20.654 2 19C2 17.346 3.346 16 5 16C6.654 16 8 17.346 8 19C8 20.654 6.654 22 5 22ZM19 22C17.346 22 16 20.654 16 19C16 17.346 17.346 16 19 16C20.654 16 22 17.346 22 19C22 20.654 20.654 22 19 22Z" fill="#4FA935"/></svg>',
  'Treinamento de fortalecimento': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.3622 8.072C20.9322 8.024 20.4732 8 20.0002 8C17.1962 8 14.8862 10.69 14.4122 11.282C13.8472 11.094 13.2052 10.978 12.4782 11C11.0972 11.031 9.89322 11.489 8.91722 12.058C9.08222 10.808 9.05322 9.638 9.02322 8.664C9.00222 8.022 8.98422 7.406 9.03322 6.951L11.3232 6.222C11.7382 6.09 12.0202 5.704 12.0202 5.269V4.988L12.8092 4.701C13.2832 4.513 13.6662 4.134 13.8602 3.662C14.0522 3.193 14.0482 2.682 13.8462 2.221C13.2552 0.872 11.7452 0 10.0002 0C8.17522 0 6.77722 1.187 6.67722 1.278C0.693216 5.88 -0.00378369 12.035 -0.00878369 16.264C-0.0107837 17.617 0.546216 18.925 1.51922 19.856C3.15022 21.413 6.68122 24.024 11.9992 24.024C16.6852 24.024 19.9652 22.801 21.8922 21.775C23.1922 21.084 23.9992 19.732 23.9992 18.249V11.054C23.9992 9.524 22.8652 8.242 21.3612 8.074L21.3622 8.072ZM22.0002 18.248C22.0002 18.99 21.5992 19.665 20.9532 20.009C19.2272 20.928 16.2732 22.024 12.0002 22.024C7.37822 22.024 4.31522 19.759 2.90022 18.41C2.31222 17.848 1.98922 17.088 1.99122 16.267C1.99622 12.138 2.67122 6.883 7.94422 2.825C7.95322 2.817 8.91122 2.001 10.0002 2.001C10.9862 2.001 11.6622 2.428 11.9432 2.89L10.6772 3.35C10.2812 3.494 10.0192 3.869 10.0192 4.289V4.539L7.87622 5.221C7.57722 5.316 7.34122 5.545 7.23622 5.84C6.95722 6.628 6.98722 7.601 7.02222 8.727C7.07422 10.426 7.14622 12.551 6.11622 14.555C6.04722 14.691 5.99922 14.839 5.99922 15.002C5.99922 15.554 6.44722 16.002 6.99922 16.002C7.31922 16.002 7.59022 15.843 7.77322 15.609C7.79322 15.584 9.77922 13.062 12.5212 13.002C14.4712 13.002 15.6182 14.486 15.6712 14.564C15.9792 15.018 16.5992 15.139 17.0562 14.832C17.5142 14.524 17.6362 13.903 17.3282 13.444C17.2962 13.396 16.9152 12.834 16.1992 12.262C16.9442 11.414 18.4992 10.002 19.9982 10.002C20.3972 10.002 20.7812 10.023 21.1382 10.063C21.6282 10.118 21.9982 10.544 21.9982 11.055V18.25L22.0002 18.248Z" fill="#4FA935"/></svg>',
  'Cashback em lojas parceiras': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_40003246_10280)"><path d="M7.98333 3.61849C7.98333 2.1691 9.16382 0.999583 10.6044 0.999583H10.9846C10.9846 0.449813 11.4348 0 11.985 0C12.5352 0 12.9854 0.449813 12.9854 0.999583H13.2555C14.326 0.999583 15.3164 1.56935 15.8566 2.49896C16.1367 2.97876 15.9667 3.5885 15.4965 3.86839C15.0163 4.14827 14.406 3.97834 14.1259 3.50854C13.9458 3.19867 13.6157 3.00875 13.2555 3.00875H10.6144C10.2743 3.00875 9.99416 3.28863 9.99416 3.62849C9.99416 3.93836 10.2143 4.19825 10.5144 4.24823L13.7957 4.798C15.0663 5.00791 15.9867 6.09746 15.9867 7.38692C15.9867 8.83632 14.8062 10.0058 13.3656 10.0058H12.9854C12.9854 10.5556 12.5352 11.0054 11.985 11.0054C11.4348 11.0054 10.9846 10.5556 10.9846 10.0058H10.7145C9.64402 10.0058 8.65361 9.43607 8.11338 8.50646C7.83326 8.02666 8.00333 7.41691 8.47353 7.13703C8.95373 6.85714 9.56398 7.02707 9.8441 7.49688C10.0242 7.80675 10.3543 7.99667 10.7145 7.99667H13.3556C13.6957 7.99667 13.9758 7.71678 13.9758 7.37693C13.9758 7.06706 13.7557 6.80716 13.4556 6.75718L10.1742 6.20741C8.90371 5.9975 7.98333 4.90795 7.98333 3.61849ZM20.3885 3.04873C18.9679 3.32861 17.9875 4.65806 17.9875 6.10746V11.1554C17.7274 11.0654 17.4473 11.0054 17.1571 10.9854C16.3668 10.9454 15.5865 11.2153 14.9862 11.7551L11.985 14.514C11.905 14.434 11.8149 14.344 11.7349 14.2641L8.99375 11.7451C8.3935 11.2053 7.61317 10.9354 6.83285 10.9854C6.54273 11.0054 6.26261 11.0554 6.0025 11.1554V5.9975C6.0025 4.14827 4.3218 2.68888 2.401 3.05873C0.980409 3.33861 0 4.66805 0 6.11745V16.0933C0 18.2124 0.84035 20.2516 2.34098 21.7509L4.29179 23.7001C4.49187 23.9 4.74198 23.99 5.00208 23.99C5.26219 23.99 5.5123 23.89 5.71238 23.7001C6.10254 23.3103 6.10254 22.6805 5.71238 22.2907L3.76157 20.3415C2.6311 19.212 2.00083 17.6926 2.00083 16.1033V5.9975C2.00083 5.44773 2.45102 4.99792 3.00125 4.99792C3.55148 4.99792 4.00167 5.44773 4.00167 5.9975C4.00167 5.9975 4.00167 14.1241 4.02168 14.1841C4.06169 14.8138 4.30179 15.4436 4.75198 15.9633L7.37307 18.6822C7.75323 19.082 8.38349 19.092 8.78366 18.7122C9.18383 18.3324 9.19383 17.6926 8.81367 17.3028L6.2426 14.6339C5.92247 14.2541 5.93247 13.6943 6.26261 13.3244C6.44268 13.1245 6.68278 13.0046 6.9529 12.9946C7.22301 12.9846 7.47311 13.0746 7.66319 13.2445L10.3943 15.7634C11.4248 16.713 12.005 18.0425 12.005 19.4419V23.0004C12.005 23.5502 12.4552 24 13.0054 24C13.5556 24 14.0058 23.5502 14.0058 23.0004V19.4419C14.0058 18.2924 13.7157 17.1628 13.1855 16.1633L16.2568 13.2945C16.6469 12.9346 17.2372 12.9346 17.6373 13.2845C18.0675 13.6743 18.0875 14.334 17.6874 14.7439L15.2864 17.2228C14.9062 17.6227 14.9162 18.2524 15.3164 18.6322C15.5065 18.8222 15.7566 18.9121 16.0067 18.9121C16.2668 18.9121 16.5269 18.8122 16.727 18.6022L19.308 15.9234C19.7482 15.4036 19.9783 14.7638 19.9983 14.1241C19.9983 14.0841 19.9983 6.0075 19.9983 6.0075C19.9983 5.45773 20.4485 5.00791 20.9987 5.00791C21.549 5.00791 21.9992 5.45773 21.9992 6.0075V16.1033C21.9992 17.6926 21.3689 19.222 20.2384 20.3415L18.2876 22.2907C17.8975 22.6805 17.8975 23.3103 18.2876 23.7001C18.4877 23.9 18.7378 23.99 18.9979 23.99C19.258 23.99 19.5081 23.89 19.7082 23.7001L21.659 21.7509C23.1596 20.2516 24 18.2224 24 16.0933V5.9975C24 4.14827 22.3193 2.68888 20.3985 3.05873L20.3885 3.04873Z" fill="#4FA935"/></g><defs><clipPath id="clip0_40003246_10280"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
  'Bike vantagens': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_40003160_97837)"><path d="M23.02 8.79007C22.43 8.25007 21.66 7.98007 20.85 8.01007C20.05 8.05007 19.31 8.40007 18.76 8.99007L15.54 12.5201C14.99 11.6101 13.99 11.0001 12.85 11.0001H4C1.79 11.0001 0 12.7901 0 15.0001V20.0001C0 22.2101 1.79 24.0001 4 24.0001H8.96C11.81 24.0001 14.53 22.7801 16.43 20.6501L23.24 13.0101C24.33 11.7801 24.23 9.89007 23.02 8.78007V8.79007ZM21.75 11.6901L14.94 19.3301C13.42 21.0301 11.25 22.0101 8.97 22.0101H4C2.9 22.0101 2 21.1101 2 20.0101V15.0101C2 13.9101 2.9 13.0101 4 13.0101H12.86C13.49 13.0101 14 13.5201 14 14.1501C14 14.7101 13.58 15.2001 13.02 15.2801L7.86 16.0201C7.31 16.1001 6.93 16.6001 7.01 17.1501C7.09 17.7001 7.6 18.0801 8.14 18.0001L13.3 17.2601C14.48 17.0901 15.43 16.2701 15.81 15.2001L20.24 10.3401C20.42 10.1401 20.67 10.0201 20.94 10.0101C21.21 10.0101 21.47 10.0901 21.67 10.2701C22.08 10.6401 22.11 11.2801 21.74 11.6901H21.75Z" fill="#4FA935"/><path d="M8.99948 10.0002H9.37948C10.8295 10.0002 11.9995 8.82023 11.9995 7.38023C11.9995 6.09023 11.0795 5.00023 9.80948 4.79023L6.52948 4.24023C6.22948 4.19023 6.00948 3.93023 6.00948 3.62023C6.00948 3.28023 6.28948 3.00023 6.62948 3.00023H9.26948C9.62948 3.00023 9.95948 3.19023 10.1395 3.50023C10.4095 3.98023 11.0195 4.14023 11.5095 3.86023C11.9895 3.58023 12.1495 2.97023 11.8695 2.49023C11.3395 1.57023 10.3395 0.990234 9.26948 0.990234H8.99948C8.99948 0.440234 8.54948 -0.00976562 7.99948 -0.00976562C7.44948 -0.00976562 6.99948 0.440234 6.99948 0.990234H6.61948C5.16948 0.990234 3.99948 2.17023 3.99948 3.61023C3.99948 4.90023 4.91948 5.99023 6.18948 6.20023L9.46948 6.75023C9.76948 6.80023 9.98948 7.06023 9.98948 7.37023C9.98948 7.71023 9.70948 7.99023 9.36948 7.99023H6.72948C6.36948 7.99023 6.03948 7.80023 5.85948 7.49023C5.57948 7.01023 4.96948 6.85023 4.48948 7.13023C4.00948 7.41023 3.84948 8.02024 4.12948 8.50023C4.65948 9.42023 5.65948 10.0002 6.72948 10.0002H6.99948C6.99948 10.5502 7.44948 11.0002 7.99948 11.0002C8.54948 11.0002 8.99948 10.5502 8.99948 10.0002Z" fill="#4FA935"/></g><defs><clipPath id="clip0_40003160_97837"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
  'Documento digital': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#dd)"><path d="M19.535 3.12202L17.879 1.46402C17.4157 0.998333 16.8646 0.629159 16.2576 0.377864C15.6507 0.126569 14.9999 -0.00185599 14.343 2.02654e-05H8C6.67441 0.00160812 5.40356 0.528902 4.46622 1.46624C3.52888 2.40358 3.00159 3.67443 3 5.00002V19C3.00159 20.3256 3.52888 21.5965 4.46622 22.5338C5.40356 23.4711 6.67441 23.9984 8 24H16C17.3256 23.9984 18.5964 23.4711 19.5338 22.5338C20.4711 21.5965 20.9984 20.3256 21 19V6.65702C21.0016 6.0002 20.873 5.34959 20.6215 4.74281C20.37 4.13604 20.0007 3.58515 19.535 3.12202ZM18.121 4.53602C18.2628 4.67734 18.3898 4.83282 18.5 5.00002H16V2.50002C16.1669 2.61134 16.3227 2.7386 16.465 2.88002L18.121 4.53602ZM19 19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.684 16.7956 22 16 22H8C7.20435 22 6.44129 21.684 5.87868 21.1213C5.31607 20.5587 5 19.7957 5 19V5.00002C5 4.20437 5.31607 3.44131 5.87868 2.8787C6.44129 2.31609 7.20435 2.00002 8 2.00002H14V5.00002C14 5.53045 14.2107 6.03916 14.5858 6.41423C14.9609 6.78931 15.4696 7.00002 16 7.00002H19V19ZM16 9.00002H8C7.73478 9.00002 7.48043 9.10538 7.29289 9.29291C7.10536 9.48045 7 9.73481 7 10C7 10.2652 7.10536 10.5196 7.29289 10.7071C7.48043 10.8947 7.73478 11 8 11H16C16.2652 11 16.5196 10.8947 16.7071 10.7071C16.8946 10.5196 17 10.2652 17 10C17 9.73481 16.8946 9.48045 16.7071 9.29291C16.5196 9.10538 16.2652 9.00002 16 9.00002ZM17 14C17 13.7348 16.8946 13.4805 16.7071 13.2929C16.5196 13.1054 16.2652 13 16 13H8C7.73478 13 7.48043 13.1054 7.29289 13.2929C7.10536 13.4805 7 13.7348 7 14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8947 7.73478 15 8 15H16C16.2652 15 16.5196 14.8947 16.7071 14.7071C16.8946 14.5196 17 14.2652 17 14ZM13 17H8C7.73478 17 7.48043 17.1054 7.29289 17.2929C7.10536 17.4805 7 17.7348 7 18C7 18.2652 7.10536 18.5196 7.29289 18.7071C7.48043 18.8947 7.73478 19 8 19H13C13.2652 19 13.5196 18.8947 13.7071 18.7071C13.8946 18.5196 14 18.2652 14 18C14 17.7348 13.8946 17.4805 13.7071 17.2929C13.5196 17.1054 13.2652 17 13 17Z" fill="#4FA935"/></g><defs><clipPath id="dd"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>',
};

const BENEFICIOS = {
  basic: [
    { nome: 'Registro da bike', descricao: '<p>Quer pedalar com mais tranquilidade? Registre sua bicicleta na Bike Registrada e garanta que ela esteja conectada ao maior sistema nacional de identificação e consulta de bicicletas.</p><p>Com o registro completo, sua bike passa a ter uma identidade única, facilitando a identificação e aumentando as chances de recuperação em caso de perda, furto ou roubo.</p><p>O cadastro é simples, rápido e pode fazer toda a diferença para proteger seu patrimônio.</p><p><strong>Importante:</strong></p><p>Cada bicicleta que o proprietário possuir precisa estar vinculada a uma assinatura ativa, podendo ser gratuita ou paga. Ou seja, se você tem mais de uma bike, será necessário registrar cada uma individualmente dentro de uma assinatura.</p>' },
    { nome: 'Certificado de transferência', descricao: '<p>Vai vender ou transferir sua companheira de pedal para outro proprietário? Com o Certificado de Transferência da Bike Registrada, o processo fica mais simples, seguro e transparente para ambas as partes.</p><p>O certificado formaliza a transferência do registro e da titularidade da bicicleta dentro da plataforma, garantindo que o novo proprietário passe a ser o responsável pela bike registrada.</p><p>A emissão é rápida e pode ser realizada de forma digital, trazendo mais praticidade na negociação.</p>' },
  ],
  starter: [
    { nome: 'Registro da bike', descricao: '<p>Quer pedalar com mais tranquilidade? Registre sua bicicleta na Bike Registrada e garanta que ela esteja conectada ao maior sistema nacional de identificação e consulta de bicicletas.</p><p>Com o registro completo, sua bike passa a ter uma identidade única, facilitando a identificação e aumentando as chances de recuperação em caso de perda, furto ou roubo.</p><p>O cadastro é simples, rápido e pode fazer toda a diferença para proteger seu patrimônio.</p><p><strong>Importante:</strong></p><p>Cada bicicleta que o proprietário possuir precisa estar vinculada a uma assinatura ativa, podendo ser gratuita ou paga. Ou seja, se você tem mais de uma bike, será necessário registrar cada uma individualmente dentro de uma assinatura.</p>' },
    { nome: 'Certificado de transferência', descricao: '<p>Vai vender ou transferir sua companheira de pedal para outro proprietário? Com o Certificado de Transferência da Bike Registrada, o processo fica mais simples, seguro e transparente para ambas as partes.</p><p>O certificado formaliza a transferência do registro e da titularidade da bicicleta dentro da plataforma, garantindo que o novo proprietário passe a ser o responsável pela bike registrada.</p><p>A emissão é rápida e pode ser realizada de forma digital, trazendo mais praticidade na negociação.</p>' },
    { nome: 'Reboque da bike', descricao: '<p>Teve um imprevisto durante o pedal? Com a Assistência 24h da Bike Registrada, você pode contar com suporte para situações como transporte, reboque ou chaveiro, garantindo mais tranquilidade sempre que precisar.</p><p>O atendimento está disponível 24 horas por dia, todos os dias da semana, porém esse benefício não está disponível no plano gratuito. A Assistência 24h é exclusiva para assinaturas pagas e segue a quantidade de requisições de livre escolha definida no plano contratado.</p>' },
    { nome: 'Assistência 24h', descricao: '<p>Teve um imprevisto durante o pedal? Com a Assistência 24h da Bike Registrada, você pode contar com suporte para situações como transporte, reboque ou chaveiro, garantindo mais tranquilidade sempre que precisar.</p><p>O atendimento está disponível 24 horas por dia, todos os dias da semana, porém esse benefício não está disponível no plano gratuito. A Assistência 24h é exclusiva para assinaturas pagas e segue a quantidade de requisições de livre escolha definida no plano contratado.</p>' },
    { nome: 'Transporte ciclista', descricao: '<p>Teve um imprevisto durante o pedal? Com a Assistência 24h da Bike Registrada, você pode contar com suporte para situações como transporte, reboque ou chaveiro, garantindo mais tranquilidade sempre que precisar.</p><p>O atendimento está disponível 24 horas por dia, todos os dias da semana, porém esse benefício não está disponível no plano gratuito. A Assistência 24h é exclusiva para assinaturas pagas e segue a quantidade de requisições de livre escolha definida no plano contratado.</p>' },
    { nome: 'Selo de identificação', descricao: '<p>Dê à sua bicicleta uma camada extra de proteção. O Selo de Identificação da Bike Registrada indica que sua bike está cadastrada no sistema nacional, funcionando como um elemento de dissuasão contra furtos e facilitando a identificação em caso de consulta.</p><p>Mais do que um adesivo, ele mostra que a bicicleta possui registro ativo e proprietário identificado, aumentando as chances de recuperação caso algo aconteça. Produzido com material resistente, foi desenvolvido para acompanhar sua bike no dia a dia. Incluindo o Bike Loc na qual envia uma notificação com a localização aproximada de onde sua bicicleta foi consultada no sistema e o Bike Vida para cadastro de informações importantes, como contato de emergência e dados médicos relevantes (ex.: tipo sanguíneo).</p>' },
  ],
  premium: [
    { nome: 'Registro da bike', descricao: '<p>Quer pedalar com mais tranquilidade? Registre sua bicicleta na Bike Registrada e garanta que ela esteja conectada ao maior sistema nacional de identificação e consulta de bicicletas.</p><p>Com o registro completo, sua bike passa a ter uma identidade única, facilitando a identificação e aumentando as chances de recuperação em caso de perda, furto ou roubo.</p><p>O cadastro é simples, rápido e pode fazer toda a diferença para proteger seu patrimônio.</p><p><strong>Importante:</strong></p><p>Cada bicicleta que o proprietário possuir precisa estar vinculada a uma assinatura ativa, podendo ser gratuita ou paga. Ou seja, se você tem mais de uma bike, será necessário registrar cada uma individualmente dentro de uma assinatura.</p>' },
    { nome: 'Certificado de transferência', descricao: '<p>Vai vender ou transferir sua companheira de pedal para outro proprietário? Com o Certificado de Transferência da Bike Registrada, o processo fica mais simples, seguro e transparente para ambas as partes.</p><p>O certificado formaliza a transferência do registro e da titularidade da bicicleta dentro da plataforma, garantindo que o novo proprietário passe a ser o responsável pela bike registrada.</p><p>A emissão é rápida e pode ser realizada de forma digital, trazendo mais praticidade na negociação.</p>' },
    { nome: 'Reboque da bike', descricao: '<p>Teve um imprevisto durante o pedal? Com a Assistência 24h da Bike Registrada, você pode contar com suporte para situações como transporte, reboque ou chaveiro, garantindo mais tranquilidade sempre que precisar.</p><p>O atendimento está disponível 24 horas por dia, todos os dias da semana, porém esse benefício não está disponível no plano gratuito. A Assistência 24h é exclusiva para assinaturas pagas e segue a quantidade de requisições de livre escolha definida no plano contratado.</p>' },
    { nome: 'Assistência 24h', descricao: '<p>Teve um imprevisto durante o pedal? Com a Assistência 24h da Bike Registrada, você pode contar com suporte para situações como transporte, reboque ou chaveiro, garantindo mais tranquilidade sempre que precisar.</p><p>O atendimento está disponível 24 horas por dia, todos os dias da semana, porém esse benefício não está disponível no plano gratuito. A Assistência 24h é exclusiva para assinaturas pagas e segue a quantidade de requisições de livre escolha definida no plano contratado.</p>' },
    { nome: 'Transporte ciclista', descricao: '<p>Teve um imprevisto durante o pedal? Com a Assistência 24h da Bike Registrada, você pode contar com suporte para situações como transporte, reboque ou chaveiro, garantindo mais tranquilidade sempre que precisar.</p><p>O atendimento está disponível 24 horas por dia, todos os dias da semana, porém esse benefício não está disponível no plano gratuito. A Assistência 24h é exclusiva para assinaturas pagas e segue a quantidade de requisições de livre escolha definida no plano contratado.</p>' },
    { nome: 'Selo de identificação', descricao: '<p>Dê à sua bicicleta uma camada extra de proteção. O Selo de Identificação da Bike Registrada indica que sua bike está cadastrada no sistema nacional, funcionando como um elemento de dissuasão contra furtos e facilitando a identificação em caso de consulta.</p><p>Mais do que um adesivo, ele mostra que a bicicleta possui registro ativo e proprietário identificado, aumentando as chances de recuperação caso algo aconteça. Produzido com material resistente, foi desenvolvido para acompanhar sua bike no dia a dia. Incluindo o Bike Loc na qual envia uma notificação com a localização aproximada de onde sua bicicleta foi consultada no sistema e o Bike Vida para cadastro de informações importantes, como contato de emergência e dados médicos relevantes (ex.: tipo sanguíneo).</p>' },
    { nome: 'Revisão da bike', descricao: '<p>Quer manter sua bicicleta sempre pronta para encarar trilhas, treinos ou o pedal do dia a dia? Com o benefício de Revisão, sua bike passa por uma verificação completa para garantir que esteja em boas condições de uso e com o funcionamento adequado para o próximo desafio. Considerando os principais componentes da bicicleta, ajudando a identificar desgastes, necessidade de ajustes e manutenção preventiva.</p>' },
    { nome: 'Consultor Bike', descricao: '<p>Quer algo ainda mais personalizado? Com o benefício Consultor Bike, você recebe uma orientação completa feita por um profissional especializado em ciclismo, focada tanto na bicicleta quanto no ciclista. Tudo é pensado para melhorar seu desempenho, conforto e segurança, ajudando você a alcançar seus objetivos com mais confiança.</p>' },
    { nome: 'Chaveiro', descricao: '<p>Perdeu a chave da sua bike ou ela quebrou? Sem problemas! Com o benefício de Chaveiro, você conta com assistência rápida para situações em que não consegue acessar sua bicicleta devido a perda, quebra de chave ou problemas com cadeados.</p>' },
    { nome: 'Bike box', descricao: '<p>Descubra uma nova forma de viver o pedal! Com o benefício Bike Box, você recebe uma caixa surpresa com itens selecionados para deixar sua experiência ainda melhor. São acessórios, equipamentos, vestuário, alimentação e brindes exclusivos pensados por ciclistas, para ciclistas. Pedale com mais estilo e praticidade!</p>' },
    { nome: 'Reparo da bike', descricao: '<p>Teve um perrengue? Não se preocupe! Com o benefício de Reparo da Bike, você conta com suporte de parceiros na região para realizar pequenos consertos e ajustes essenciais na loja, garantindo que sua bicicleta volte a funcionar corretamente.</p>' },
    { nome: 'Nutrição esportiva', descricao: '<p>Quer pedalar mais e melhor? Então vamos cuidar da sua alimentação! Com o benefício de Nutricionista Esportivo, você conta com acompanhamento profissional para criar um plano alimentar personalizado, voltado para melhorar seu desempenho, aumentar sua resistência e ajudar na recuperação, garantindo mais energia e força para encarar qualquer pedal.</p>' },
    { nome: 'Manutenção da bike', descricao: '<p>Manter sua bike em dia é essencial para garantir um pedal sem surpresas. Com o benefício de Manutenção da Bike, você conta com suporte para serviços de manutenção, incluindo ajustes, lubrificação e mão de obra para troca de peças, ajudando a manter sua bicicleta funcionando de forma segura e eficiente por muito mais tempo.</p>' },
    { nome: 'Bike fit', descricao: '<p>Pedalar com conforto e eficiência faz toda a diferença! Com o benefício Bike Fit, você conta com um ajuste profissional da bicicleta conforme o seu corpo, garantindo uma posição mais adequada para pedalar. Isso ajuda a evitar dores, melhorar o conforto e aumentar sua performance, tornando o pedal mais seguro e eficiente.</p>' },
    { nome: 'Treino de ciclista', descricao: '<p>Seja você iniciante, intermediário ou avançado, sempre existe um treino ideal para evoluir no pedal. Com o benefício de Treinamento para Ciclista, você recebe um plano personalizado, desenvolvido para melhorar seu desempenho, aumentar sua resistência e aprimorar sua técnica, ajudando você a alcançar suas metas com mais eficiência e consistência.</p>' },
    { nome: 'Treinamento de fortalecimento', descricao: '<p>Quer ficar mais forte no pedal? Com o benefício de Treinamento de Fortalecimento Muscular, você conta com um programa desenvolvido especialmente para ciclistas, focado em melhorar seu desempenho, aumentar a resistência e prevenir lesões. É força e preparo na medida certa para encarar qualquer desafio sobre duas rodas.</p>' },
    { nome: 'Cashback em lojas parceiras', descricao: '<p>Com o benefício de Cashback em Lojas Parceiras, você recebe de volta uma parte do valor gasto em suas compras. É uma forma inteligente de economizar e transformar despesas do dia a dia em recompensas. Aproveite e veja seu dinheiro render ainda mais, comprando em uma rede com mais de 25 mil estabelecimentos parceiros.</p>' },
    { nome: 'Bike vantagens', descricao: '<p>Entre para o Clube de Vantagens e aproveite uma série de benefícios exclusivos para ciclistas! Com o Bike Vantagens, você tem acesso a descontos em lojas parceiras, ofertas especiais em equipamentos, cupons promocionais para desafios e competições, além de outras vantagens pensadas para deixar sua experiência sobre duas rodas ainda melhor. Pedalar fica muito mais vantajoso!</p>' },
  ],
};

const PLANO_IDS = {
  basic: "a1a4c471-4e62-4aea-af47-debf1075ac99",
  starter: "fbfcf99f-2a25-4224-bb46-76b9c85bc741",
  premium: "40f2fa99-ab2c-40a3-9206-8c8640c8253a",
};

export default {
  name: "TiposRegistro",
  components: { RegistroBikeStepper, Swiper, SwiperSlide },
  data() {
    return {
      nome: "",
      planSelecionado: null,
      carregando: false,
      erroApi: "",
      modalAberto: false,
      modalPlano: null,
      expandidoItem: null,
      upsellAberto: false,
      swiperInstance: null,
      icones: ICONES,
      planos: {
        basic: {
          features: ["Registro da bike", "Certificado de transferência"],
        },
        starter: {
          features: [
            "Reboque da bike",
            "Assistência 24h",
            "Transporte ciclista",
            "Selo de identificação",
            "Documento digital",
          ],
        },
        premium: {
          features: [
            "Personal fit",
            "Revisão da bike",
            "Bike box",
            "Chaveiro",
            "Nutrição esportiva",
            "Reparo da bike",
            "Bike fit",
            "Manutenção da bike",
            "Treinamento de fortalecimento",
            "Treino de ciclista",
            "Bike vantagens",
            "Cashback em lojas parceiras",
          ],
        },
      },
    };
  },
  computed: {
    initialSlide() {
      if (this.planSelecionado === 'premium') return 2;
      if (this.planSelecionado === 'starter') return 1;
      return 0;
    },
    primeiroNome() {
      return this.nome.split(' ')[0];
    },
    modalPlanoNome() {
      const nomes = { basic: 'Basic', starter: 'Starter', premium: 'Premium' };
      return nomes[this.modalPlano] || '';
    },
    modalBeneficios() {
      const lista = BENEFICIOS[this.modalPlano] || [];
      return lista.map(b => ({ nome: b.nome, descricao: b.descricao || '', icone: ICONES[b.nome] || '' }));
    },
  },
  created() {
    this.nome = sessionStorage.getItem("registro_nome") || "";
    if (!this.nome) {
      this.$router.replace({ name: "registro-bike-dados" });
      return;
    }
    this.planSelecionado = sessionStorage.getItem("registro_plano") || null;
  },
  methods: {
    abrirModal(plano) {
      this.modalPlano = plano;
      this.modalAberto = true;
      document.body.style.overflow = 'hidden';
    },
    fecharModal() {
      this.modalAberto = false;
      this.modalPlano = null;
      this.expandidoItem = null;
      document.body.style.overflow = '';
    },
    toggleItem(nome) {
      this.expandidoItem = this.expandidoItem === nome ? null : nome;
    },
    voltar() {
      this.$router.back();
    },
    fecharUpsell() {
      this.upsellAberto = false;
      document.body.style.overflow = '';
    },
    onSwiperInit(swiper) {
      this.swiperInstance = swiper;
    },
    selecionarPlano(plano) {
      const indices = { basic: 0, starter: 1, premium: 2 };
      this.planSelecionado = plano;
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(indices[plano], 300);
      }
      this.$nextTick(() => {
        if (this.$refs.planosSection) {
          this.$refs.planosSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    irParaPremiumViaSwiper() {
      this.upsellAberto = false;
      document.body.style.overflow = '';
      this.planSelecionado = 'starter';
      setTimeout(() => {
        this.selecionarPlano('starter');
      }, 50);
    },
    async confirmarGratuito() {
      if (this.carregando) return;
      this.erroApi = "";
      this.carregando = true;
      try {
        auth.getUserInfo();
        const idCliente = sessionStorage.getItem("registro_id_cliente");
        const idPlano = PLANO_IDS['basic'];
        await axios.post(
          `${config.API_URLV2}/AssinaturaRegistro/FinalizarSemCobranca`,
          { IdPlano: idPlano, IdCliente: idCliente }
        );
        const emailCliente = sessionStorage.getItem("registro_email");
        this.$router.push({ path: "/pagamento-aprovado-registro", query: { email: emailCliente } });
      } catch (e) {
        this.erroApi = "Ocorreu um erro ao finalizar o registro. Tente novamente.";
        this.upsellAberto = false;
      } finally {
        document.body.style.overflow = '';
        this.carregando = false;
      }
    },
    continuar() {
      if (!this.planSelecionado || this.carregando) return;
      if (this.planSelecionado === 'basic') {
        this.upsellAberto = true;
        document.body.style.overflow = 'hidden';
        return;
      }
      const planoNome = { starter: 'Starter', premium: 'Premium' };
      const planoValor = { starter: 9.90, premium: 29.90 };
      sessionStorage.setItem("registro_plano", this.planSelecionado);
      sessionStorage.setItem("registro_id_plano", PLANO_IDS[this.planSelecionado]);
      sessionStorage.setItem("registro_plano_nome", planoNome[this.planSelecionado]);
      sessionStorage.setItem("registro_plano_valor", planoValor[this.planSelecionado]);
      this.$router.push({ name: "registro-bike-finalizacao" });
    },
  },
};
</script>

<style scoped>
.pagina {
  min-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f9f9f9;
  background-image: url(/img/bike-mundo.svg);
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 30%;
  font-family: Inter !important;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Header */
.header {
  padding: 16px 32px;
  padding-top: calc(16px + env(safe-area-inset-top));
  background: #f9f9f9;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 10;
}

/* Conteúdo */
.conteudo {
  flex: 1;
  padding: 40px 0;
  position: relative;
  z-index: 10;
  max-width: 1085px;
  width: 100%;
  margin: 0 auto;
}

.page-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 40px 48px;
}

.titulo {
  font-size: 24px;
  font-weight: 700;
  color: #475569;
  line-height: 1.3;
  margin-bottom: 6px;
}

.nome-destaque {
  color: #4FA935;
}

.subtitulo {
  font-size: 14px;
  color: #64748B;
  margin-bottom: 20px;
}

/* Seletor de planos (tabs) */
.tab-planos {
  display: none;
  gap: 8px;
  margin-bottom: 16px;
}

@media (max-width: 600px) {
  .tab-planos {
    display: flex;
  }

  .pagina {
    background-size: 75%;
  }
}

.tab-plano {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 8px 15px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  position: relative;
}

.tab-plano.ativo {
  background: #4FA935;
  border-color: #4FA935;
}

.tab-plano.ativo .tab-nome {
  color: #fff;
}

.tab-nome {
  font-size: 15px;
  font-weight: 700;
  color: #425994;
}

.tab-preco {
  position: absolute;
  bottom: -11px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #F1F5F9;
  font-size: 11px;
  font-weight: 500;
  color: #64748B;
  white-space: nowrap;
  gap: 4px;
}

.tab-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: #A6E894;
  color: #2d7a1f;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
  white-space: nowrap;
}

/* Grid de planos */
.planos-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.planos-swiper {
  display: none;
  margin-bottom: 20px;
}

.plano-wrapper {
  display: flex;
  flex-direction: column;
}

.badge-espaco {
  height: 28px;
}

.badge-destaque {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #4FA935;
  margin-bottom: 0;
}

.plano-card {
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  transition: border-color 0.25s, box-shadow 0.25s, transform 0.25s, background 0.25s;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  will-change: transform;
}

.plano-card:hover {
  border-color: #4FA935;
  box-shadow: 0 6px 20px rgba(79, 169, 53, 0.15);
  transform: translateY(-4px);
  background: #fafff8;
}

.plano-card.selecionado {
  border-color: #4FA935;
  box-shadow: 0 0 0 2px rgba(79, 169, 53, 0.2), 0 6px 20px rgba(79, 169, 53, 0.12);
  background: #fafff8;
}

.plano-topo {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.checkbox-icone {
  flex-shrink: 0;
  line-height: 0;
}

.plano-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.plano-tipo-label {
  font-size: 12px;
  color: #425994;
}

.plano-nome {
  font-size: 20px;
  font-weight: 700;
  color: #425994;
}

.plano-descricao {
  font-size: 13px;
  color: #425994;
  margin: 0;
}

.destaque-plano {
  color: #4FA935;
}

/* Features */
.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.features-list--2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 8px;
  align-content: start;
}

.features-list li {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #425994;
  line-height: 1.4;
}

.features-list li svg {
  flex-shrink: 0;
  margin-top: 0px;
}

/* Benefícios link */
.plano-beneficios {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4FA935;
  font-weight: 500;
  cursor: pointer;
  margin-top: auto;
}

.plano-beneficios>svg:first-child {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.plano-beneficios>svg:last-child {
  margin-left: auto;
}

/* Preço */
.plano-preco {
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 74px;
}

.preco-gratuito {
  font-size: 22px;
  font-weight: 700;
  color: #425994;
}

.preco-de {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 4px;
}

.preco-original {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
}

.badge-desconto {
  font-size: 11px;
  font-weight: 600;
  color: #4FA935;
  background: #eaf7e4;
  border-radius: 4px;
  padding: 2px 6px;
}

.preco-valor {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0;
}

.preco-cifrao {
  font-size: 13px;
  font-weight: 700;
  color: #425994;
}

.preco-numero {
  font-size: 32px;
  font-weight: 700;
  color: #425994;
  line-height: 1;
}

.preco-centavos {
  font-size: 13px;
  font-weight: 600;
  color: #425994;
  align-self: flex-end;
  padding-bottom: 3px;
}

/* === Estado selecionado: card verde === */
.plano-card.selecionado {
  background: #4FA935;
  border-color: #4FA935;
  box-shadow: 0 8px 24px rgba(79, 169, 53, 0.35);
  transform: translateY(-4px);
}

.plano-card.selecionado .plano-nome,
.plano-card.selecionado .plano-tipo-label,
.plano-card.selecionado .plano-descricao,
.plano-card.selecionado .destaque-plano,
.plano-card.selecionado .features-list li,
.plano-card.selecionado .preco-gratuito,
.plano-card.selecionado .preco-cifrao,
.plano-card.selecionado .preco-numero,
.plano-card.selecionado .preco-centavos {
  color: #fff;
}

.plano-card.selecionado .features-list li svg path {
  stroke: #fff;
}

.plano-card.selecionado .plano-beneficios {
  color: #fff;
}

.plano-card.selecionado .plano-beneficios svg path,
.plano-card.selecionado .plano-beneficios svg polyline,
.plano-card.selecionado .plano-beneficios svg line,
.plano-card.selecionado .plano-beneficios svg rect {
  fill: #FAFAFA;
}

.plano-card.selecionado .plano-preco {
  border-top-color: rgba(255, 255, 255, 0.3);
}

.plano-card.selecionado .preco-original {
  color: rgba(255, 255, 255, 0.7);
}

.plano-card.selecionado .badge-desconto {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.plano-card.selecionado:hover {
  background: #4FA935;
}

/* Rodapé do form */
.rodape-form {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-voltar {
  border: none;
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #F0F3F8;
  color: #425994;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.btn-voltar:hover {
  background: #f0f0f0;
}

.btn-continuar {
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  background: #4FA935;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-continuar:hover:not(:disabled) {
  background: #3d8a28;
}

.btn-continuar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Footer */
.footer {
  padding: 14px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #64748B;
  position: relative;
  z-index: 10;
}

.footer-contatos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-contatos a {
  color: #4FA935;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
}

.footer-contatos a:hover {
  color: #4FA935;
}

/* ── Modal Benefícios ── */
.beneficios-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.beneficios-card {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 882px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
}

.beneficios-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 24px 28px 12px;
  flex-shrink: 0;
}

.beneficios-scroll {
  overflow-y: auto;
  flex: 1;
  padding: 0 28px 28px;
}

.beneficios-scroll::-webkit-scrollbar {
  width: 4px;
}

.beneficios-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.beneficios-scroll::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 99px;
}

.beneficios-scroll::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}

.beneficios-card .modal-fechar {
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px;
  line-height: 0;
  flex-shrink: 0;
  margin: -8px -8px 0 0;
}

.modal-titulo {
  font-size: 20px;
  font-weight: 700;
  color: #425994;
  margin: 0 0 4px;
}

.modal-plano-nome {
  color: #4FA935;
}

.modal-subtitulo {
  font-size: 13px;
  color: #94A3B8;
  margin: 0 0 20px;
}

.modal-lista {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 10px;
  transition: background 0.15s;
}

.modal-item:hover {
  background: #F8FAFC;
}

.modal-item-texto {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.modal-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.modal-item-chevron {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.modal-item-chevron.expandido {
  transform: rotate(0deg);
}

.modal-icone {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-item-nome {
  padding-top: 4px;
  font-size: 14px;
  color: #425994;
  font-weight: 500;
  line-height: 1.3;
}

.modal-item-desc {
  font-size: 12px;
  color: #64748B;
  line-height: 1.6;
}

.modal-item-desc p {
  margin: 0 0 8px;
}

.modal-item-desc p:last-child {
  margin-bottom: 0;
}

.modal-item-desc strong {
  color: #425994;
  font-weight: 600;
}

@media (max-width: 768px) {
  .upsell-imagem {
    max-width: 60% !important;
  }

  .conteudo {
    padding: 28px 20px;
  }

  .page-content {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
  }

  .planos-desktop {
    display: none;
  }

  .planos-swiper {
    display: block;
    margin-left: -20px;
    margin-right: -20px;
  }

  .planos-swiper .swiper-wrapper {
    align-items: stretch;
  }

  .planos-swiper .swiper-slide {
    height: auto;
  }

  .planos-swiper .plano-wrapper {
    height: 100%;
  }

  .planos-swiper .plano-card {
    height: 100%;
    box-sizing: border-box;
  }

  .swiper-plans-container {
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
  }

  ::v-deep .swiper-pagination-bullet {
    background: #4FA935 !important;
    opacity: 0.4;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background: #4FA935 !important;
    opacity: 1;
  }

  .footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 14px 20px;
    font-size: 10px;
    color: #64748B;
    text-align: left;
  }

  .header {
    background: #fff;
    border-bottom: 1px solid #E2E8F0;
  }
}

/* ── Modal upsell plano gratuito ── */
.upsell-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.upsell-card {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 92vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
}

.upsell-fechar {
  position: absolute;
  top: 14px;
  right: 14px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  line-height: 0;
  z-index: 1;
}

.upsell-imagem {
  display: block;
  margin: 24px auto 8px;
  max-width: 100%;
}

.upsell-corpo {
  padding: 20px 24px 28px;
}

.upsell-titulo {
  font-size: 18px;
  font-weight: 700;
  color: #425994;
  margin: 0 0 10px;
  line-height: 1.35;
  text-align: center;
}

.upsell-nome {
  color: #4FA935;
}

.upsell-subtitulo {
  font-size: 13px;
  color: #64748B;
  margin: 0 0 18px;
  line-height: 1.6;
  text-align: center;
}

.upsell-subtitulo strong {
  color: #425994;
}

.upsell-lista {
  list-style: none;
  padding: 0;
  margin: 0 0 22px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
}

.upsell-lista li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #425994;
  font-weight: 500;
}

.upsell-icone {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upsell-botoes {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.btn-eu-quero {
  flex: 1;
  padding: 7px;
  border-radius: 8px;
  border: none;
  background: #4FA935;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-eu-quero:hover {
  background: #3d8a28;
}

.btn-perder {
  flex: 1;
  padding: 7px;
  border-radius: 8px;
  border: 1.5px solid #CBD5E1;
  background: #fff;
  color: #64748B;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}

.btn-perder:hover:not(:disabled) {
  border-color: #94A3B8;
  color: #425994;
}

.btn-perder:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
